// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

label {
  font-family: "Open Sans", sans-serif;
}

li {
  list-style: none;
}

::ng-deep#page-wrapper {
  padding-bottom: 60px;
}

::ng-deep#wrapper {
  overflow-x: initial;
}

::ng-deep.warm-up-is .mainnav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 30px 0 40px;
}
::ng-deep.warm-up-is .mainnav.mainnav--bottom {
  margin: 80px 0 70px;
}
::ng-deep.warm-up-is .mainnav.mainnav--bottom ul li a {
  padding: 12px 30px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
::ng-deep.warm-up-is .info {
  color: #fff;
  margin-bottom: 25px;
  padding: 20px 40px;
  border-radius: 6px;
  width: 100%;
}
::ng-deep.warm-up-is .info-outer {
  display: flex;
}
::ng-deep.warm-up-is .info-outer .info-right-icon {
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}
::ng-deep.warm-up-is .info-outer .info-right-icon svg {
  width: 40px;
}
::ng-deep.warm-up-is .info-outer .info-right-icon--bg {
  background-color: #6d6e71;
}
::ng-deep.warm-up-is .info.infotitle {
  background-color: #6d6e71;
}
::ng-deep.warm-up-is .info.infotitle--editmode {
  padding: 4px 40px;
}
::ng-deep.warm-up-is .info.infotitle--editmode h1 {
  font-size: 25px;
}
::ng-deep.warm-up-is .info h1 {
  font-size: 36px;
  margin: 0;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
::ng-deep.warm-up-is .info h1 small {
  color: #fff;
  font-size: 80%;
}
::ng-deep.warm-up-is .info .card__toprow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol {
  padding: 0 15px;
  width: 33.3333333333%;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tt {
  margin-left: auto;
  text-align: right;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--title > div:first-child {
  margin-right: 15px;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--startexist {
  width: 65%;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  border-radius: 3px;
  line-height: 1;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button svg {
  right: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button span.card__topcount {
    left: -30px;
  }
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button svg {
  left: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button span.card__topcount {
    right: -30px;
  }
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li:not(:first-child) {
  margin-left: -1px;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li:only-child button {
  border-radius: 3px;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button {
  color: #6d6e71;
  border: 1px solid #6d6e71;
  cursor: pointer;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount {
  color: #6d6e71;
  background-color: #efefef;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button {
  opacity: 0.2;
  border: 1px solid #6d6e71;
  color: #6d6e71;
  cursor: pointer;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount {
  color: #6d6e71;
  background-color: #efefef;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
  position: relative;
  color: rgb(105, 190, 40);
  font-size: 17px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg {
  position: absolute;
  top: -1px;
  height: calc(100% + 2px);
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg .st0 {
  fill: #6d6e71;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
    padding: 4px 6px;
    font-size: 13px;
  }
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:focus {
  outline: none;
  box-shadow: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topdesktext {
    display: none;
  }
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
  display: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
    display: inline-block;
  }
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: inline-block;
  text-align: center;
  font-size: 0.5em;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 4px;
  border-radius: 50%;
  vertical-align: bottom;
  position: relative;
  top: -1px;
}
@media only screen and (max-width: 630px) {
  ::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
    position: absolute;
    top: auto;
    bottom: -2px;
    right: 0;
    margin: 0;
  }
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover {
  color: #6d6e71;
  opacity: 1;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover > span.card__topcount {
  color: #6d6e71;
  background-color: #efefef;
  opacity: 1;
}
::ng-deep.warm-up-is .info .card__toprow .card__topcol .card__bwnh3pencil a {
  color: #6d6e71;
  margin-left: 15px;
}
::ng-deep.warm-up-is .info .card__toprow .card__h3button {
  border: 1px solid #6d6e71;
  background-color: transparent;
  margin-left: 10px;
  padding: 2px 26px;
  border-radius: 3px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: #6d6e71;
  font-size: 22px;
  transition: all ease 0.3s;
  cursor: pointer;
}
@media only screen and (max-width: 1200px) {
  ::ng-deep.warm-up-is .info .card__toprow .card__h3button {
    padding: 2px 12px;
  }
}
::ng-deep.warm-up-is .info .card__toprow .card__h3button:hover {
  background-color: #6d6e71;
  color: #fff;
}
::ng-deep.warm-up-is .info .card__toprow .card__h3button:focus {
  outline: none;
}
::ng-deep.warm-up-is .info .card__toprow .tooltipicon {
  cursor: pointer;
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.warm-up-is .info .card__toprow .tooltipicon i {
  color: #6d6e71;
}
::ng-deep.warm-up-is .info .card__toprow .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.warm-up-is .info .card__toprow .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: #6d6e71;
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.warm-up-is .info h3 {
  font-size: 22px;
  margin: 0;
  cursor: pointer;
  color: #6d6e71;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 1200px) {
  ::ng-deep.warm-up-is .info h3 {
    font-size: 19px;
  }
}
::ng-deep.warm-up-is .info h3 i {
  cursor: pointer;
  font-size: 0.9em;
}
::ng-deep.warm-up-is .info h3 i + div {
  padding-left: 7px;
}
::ng-deep.warm-up-is .info h3 i + div span {
  display: block;
  font-size: 0.7em;
}
::ng-deep.warm-up-is .info h3 i + span {
  padding-left: 7px;
}
::ng-deep.warm-up-is .info h3.d-flex {
  display: flex;
}
::ng-deep.warm-up-is .info h3.d-flex div:first-child {
  padding-right: 10px;
}
::ng-deep.warm-up-is .info h3.d-flex div:nth-child(2) span {
  display: block;
}
::ng-deep.warm-up-is .info .tooltipicon {
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.warm-up-is .info .tooltipicon i {
  color: #6d6e71;
}
::ng-deep.warm-up-is .info .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.warm-up-is .info .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: #6d6e71;
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.warm-up-is .card-default {
  border-radius: 6px;
  border-top-width: 3px;
  border: 0;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
::ng-deep.warm-up-is .card-default + div {
  margin-top: 30px;
}
::ng-deep.warm-up-is .card-default .info {
  margin: 0;
  border: 1px solid #6d6e71;
  border-radius: 6px;
}
::ng-deep.warm-up-is .card-default .info.card__headactive {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
::ng-deep.warm-up-is .card-default .info.card__headactive--wc {
  background-color: #6d6e71;
}
::ng-deep.warm-up-is .card-default .info.card__headactive--wc .card__topcol h3 {
  color: #fff;
}
::ng-deep.warm-up-is .card-default .info.card__headactive--wc .card__topcol ul li button {
  border-color: #fff;
  background-color: #fff;
}
::ng-deep.warm-up-is .card-default .info.card__headactive--wc .card__topcol ul li button span {
  color: #6d6e71;
  background-color: #fff;
}
::ng-deep.warm-up-is .card-default .info.card__headactive--wc .card__topcol ul li button .st0 {
  fill: #fff !important;
}
::ng-deep.warm-up-is .card-default .info.card__headactive--wc i {
  color: #fff;
}
::ng-deep.warm-up-is .card-default .card-body__inner {
  padding: 15px 40px;
}
::ng-deep.warm-up-is .card-default .card-body {
  display: none;
  border: 1px solid #CFDBE2;
  border-top: 0;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}
::ng-deep.warm-up-is .card-default .card-body.card-show {
  display: block;
}
::ng-deep.warm-up-is .card-default .card-body.card-show__wbg {
  background-color: #fff;
}
::ng-deep.warm-up-is .card-default .card-body__finalstate p {
  font-size: 15px;
  font-weight: 600;
}
::ng-deep.warm-up-is .card-default .card-body__finalstate p:last-child {
  margin-bottom: 0;
}
::ng-deep.warm-up-is .card-default .card-body__finalstate--2 {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}
::ng-deep.warm-up-is .card-default .card-body__finalstate--2 > div {
  width: 50%;
  padding: 0 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.warm-up-is .card-default .card-body__finalstate--2 > div {
    width: 100%;
  }
}
::ng-deep.warm-up-is .card-default .card-body__finalstate--2 > div p {
  position: relative;
  padding-left: 10px;
}
::ng-deep.warm-up-is .card-default .card-body__finalstate--2 > div p::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.warm-up-is .card-default .c-radio label {
  padding-left: 0;
}
::ng-deep.warm-up-is .card-default .c-radio input {
  opacity: 0;
  margin: 0;
}
::ng-deep.warm-up-is .card-default .c-radio input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 5px;
  text-align: center;
}
::ng-deep.warm-up-is .card-default .c-radio input + span::before {
  position: absolute;
  color: #5D9CEC;
  opacity: 0;
  font-size: 11px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.warm-up-is .card-default .c-radio input:checked + span {
  border-color: #6d6e71;
}
::ng-deep.warm-up-is .card-default .c-radio input:checked + span::before {
  opacity: 1;
}
::ng-deep.warm-up-is .card-default .checkbox {
  margin-top: 0;
}
::ng-deep.warm-up-is .card-default .checkbox label {
  min-height: 20px;
  padding-left: 0;
  margin-bottom: 0;
  font-weight: 400;
  cursor: pointer;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.warm-up-is .card-default .checkbox label > i {
  position: relative;
  top: 1px;
  margin-right: 6px;
}
::ng-deep.warm-up-is .card-default .checkbox label > span {
  vertical-align: middle;
}
::ng-deep.warm-up-is .card-default .checkbox input {
  opacity: 0;
  position: absolute;
  display: none;
}
::ng-deep.warm-up-is .card-default .checkbox input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.warm-up-is .card-default .checkbox input + span::before {
  font-size: 12px;
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.warm-up-is .card-default .checkbox input:checked + span {
  border-color: #6d6e71;
  background-color: #6d6e71;
}
::ng-deep.warm-up-is .card-default .checkbox input:checked + span::before {
  opacity: 1;
}
::ng-deep.warm-up-is .card-default .card-body__button {
  background-color: #f5f5f5;
  border-top: 1px solid #e3e3e3;
  padding: 12px 40px;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  transition: all ease 0.3s;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn + .btn {
  margin-left: 15px;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .float-right {
  margin-left: auto;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-warm {
  background-color: #6d6e71;
  border-color: #6d6e71;
  color: #fff;
  font-weight: 700;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-warm--mr {
  margin-right: 10px;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-warm:hover {
  background-color: #6d6e71;
  border-color: #6d6e71;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-warm i {
  margin-right: 8px;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-success {
  background-color: #27c24c;
  border-color: #27c24c;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-success:hover {
  background-color: #21A240;
  border-color: #1E983B;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-danger {
  background-color: #fff;
  border-color: #fff;
  color: #ef6272;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-danger:hover {
  background-color: #ED2D2D;
  border-color: #EC2121;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-warning em {
  margin: 0;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
  font-weight: 700;
  color: #6D6E71;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-deleteall:hover {
  background-color: #fff;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-deleteall:hover i {
  margin-right: 6px;
}
::ng-deep.warm-up-is .card-default .card-body__button .card-button .btn-deleteall i {
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.warm-up-is .card-default .note-3 {
  padding: 15px 15px 10px;
  border: 2px solid rgb(0, 173, 208);
  margin-bottom: 15px;
}
::ng-deep.warm-up-is .card-default .note-3 label {
  color: rgb(0, 173, 208);
}
::ng-deep.warm-up-is .card-default .footer-line {
  color: rgb(0, 173, 208);
}
::ng-deep.warm-up-is .card-default p {
  font-size: 15px;
}
::ng-deep.warm-up-is .card-default p:last-child {
  margin-bottom: 0;
}
::ng-deep.warm-up-is .card-default .card-body__edit {
  position: relative;
}
::ng-deep.warm-up-is .card-default .card-body__edit .breakthrough-input-tabs,
::ng-deep.warm-up-is .card-default .card-body__edit .datadump-input-tabs {
  width: 100%;
  margin-right: 0;
  position: relative;
}
::ng-deep.warm-up-is .card-default .card-body__edit .breakthrough-input-tabs input,
::ng-deep.warm-up-is .card-default .card-body__edit .breakthrough-input-tabs select,
::ng-deep.warm-up-is .card-default .card-body__edit .datadump-input-tabs input,
::ng-deep.warm-up-is .card-default .card-body__edit .datadump-input-tabs select {
  height: 50px;
  padding: 10px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 15px;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow > div {
  padding: 0 15px;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow > div .card-body__editcol.hideblk {
  display: none;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol--2 {
  width: 50%;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow > div > div {
  position: relative;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow select {
  appearance: none;
  background-image: url("https://assets.foursightonline.com/app/images/select.png");
  background-size: 10px;
  background-position: right 10px center;
  background-repeat: no-repeat;
  font-family: "Open Sans";
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow select:focus {
  outline: none;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow textarea {
  width: 100%;
  border: 1px solid #ccc;
  resize: none;
  border-radius: 3px;
  padding: 10px 15px;
  font-size: 15px;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel {
  width: 35px;
  padding-right: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber {
  width: 40px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-right: 0;
  border-radius: 4px 0 0 4px;
  font-weight: 700;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput {
  width: calc(100% - 41px);
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce {
  position: relative;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 7px;
  font-size: 26px;
  color: #6d6e71;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip, ::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon:active > .card-body__tooltip,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon:active > .card-body__tooltip {
  display: block;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon .card-body__tooltip,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon .card-body__tooltip {
  display: none;
  font-size: 16px;
  color: #676a6c;
  position: absolute;
  bottom: 100%;
  left: 0;
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: max-content;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce input,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce input {
  padding-left: 26px;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
  width: 315px;
  padding-right: 15px;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
  width: calc(100% - 351px);
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input {
  padding-right: 70px;
  font-family: "Open Sans";
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus {
  outline: none;
}
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child,
::ng-deep.warm-up-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child {
  width: 100%;
}
::ng-deep.warm-up-is .card-default .card-body__edit + .card-body__addnew button {
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  border: 1px solid transparent;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
  cursor: pointer;
  color: #6d6e71;
  font-weight: 700;
}
::ng-deep.warm-up-is .card-default .card-body__edit + .card-body__addnew button:hover {
  background-color: #6d6e71;
  border: 1px solid #6d6e71;
  color: #fff;
  padding-right: 12px;
  padding-left: 12px;
}
::ng-deep.warm-up-is .card-default .breakthrough-input-tabs {
  width: 90%;
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.warm-up-is .card-default .input-tabs {
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding: 0 0 0 0;
  margin: 0;
}
::ng-deep.warm-up-is .card-default .input-tabs + i {
  position: relative;
  top: -1px;
}
::ng-deep.warm-up-is .card-default .input-tabs .select_faded {
  opacity: 0.2;
  padding-left: 32px;
}
::ng-deep.warm-up-is .card-default .input-tabs input,
::ng-deep.warm-up-is .card-default .input-tabs select {
  height: 50px;
  padding: 10px 15px;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  margin: 7px 0px;
}
::ng-deep.warm-up-is .card-default .input-tabs label {
  width: 20px;
  margin: 0;
}
::ng-deep.warm-up-is .card-default .input-tabs select {
  width: 9%;
}
::ng-deep.warm-up-is .card-default .input-tabs input {
  width: 90%;
  margin-left: 15px;
}
::ng-deep.warm-up-is .card-default .input-group-text {
  cursor: pointer;
  padding: 3px 16px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.528571429;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #E9ECEF;
  border: 1px solid #DDE6E9;
  border-radius: 0.25rem;
  position: absolute;
  top: calc(50% + 1px);
  right: 12px;
  transform: translateY(-50%);
  transition: all ease 0.3s;
}
::ng-deep.warm-up-is .card-default .input-group-text:hover {
  background-color: #6d6e71;
  border-color: #6d6e71;
  color: #fff;
}
::ng-deep.warm-up-is .card-default .list-columns {
  display: flex;
  flex-wrap: wrap;
  counter-reset: section;
}
::ng-deep.warm-up-is .card-default .list-columns > div {
  width: 50%;
}
::ng-deep.warm-up-is .card-default .list-columns > div.card__body--cswrapper {
  width: 100%;
  position: relative;
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 5px;
  margin-bottom: 10px;
}
::ng-deep.warm-up-is .card-default .list-columns > div.card__body--cswrapper::before, ::ng-deep.warm-up-is .card-default .list-columns > div.card__body--cswrapper::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: 100%;
  width: 40px;
  height: 1px;
  background-color: #e4e4e4;
}
::ng-deep.warm-up-is .card-default .list-columns > div.card__body--cswrapper::after {
  right: auto;
  left: 100%;
}
::ng-deep.warm-up-is .card-default .list-columns.list-columns--2 > div {
  width: 100%;
}
::ng-deep.warm-up-is .card-default .list-columns .brainstorm-tabs {
  position: relative;
  padding-left: 23px;
}
::ng-deep.warm-up-is .card-default .list-columns .brainstorm-tabs::before {
  counter-increment: section;
  content: counter(section) ".";
  position: absolute;
  top: 0;
  left: 0;
}
::ng-deep.warm-up-is .idea-shop-list {
  padding: 20px;
  margin-left: 17px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.warm-up-is .idea-shop-list li {
  width: 50%;
  margin-bottom: 10px;
}
::ng-deep.warm-up-is .brainstorm__col {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 17px;
}
::ng-deep.warm-up-is .brainstorm__col .brainstorm-main {
  width: calc(100% - 68px);
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.warm-up-is .brainstorm__col .brainstorm-main .brainstorm-group {
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.warm-up-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend {
  margin-right: -1px;
  width: 45px;
}
::ng-deep.warm-up-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend .input-group-text {
  background: transparent;
  border-color: #6d6e71;
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
::ng-deep.warm-up-is .brainstorm__col .brainstorm-main .brainstorm-group input {
  width: calc(100% - 45px);
  height: 35px;
  border: 1px solid rgb(255, 121, 0);
  border-radius: 0 0.25rem 0.25rem 0;
}
::ng-deep.warm-up-is .card-bottom-button .button {
  font-size: 13px;
  color: #fff;
  padding: 8px 10px;
  border-radius: 3px;
  transition: all ease 0.3s;
}
::ng-deep.warm-up-is .card-bottom-button .button:hover {
  opacity: 0.8;
}
::ng-deep.warm-up-is .card-bottom-button .button i {
  font-size: 0.8em;
}
::ng-deep.warm-up-is .card-bottom-button .button.btn-clarify {
  background-color: rgb(0, 173, 208);
}
::ng-deep.warm-up-is .card-bottom-button .button.btn-ideate {
  background-color: rgb(255, 121, 0);
}
::ng-deep.warm-up-is .card-bottom-button .button.btn-implement {
  background-color: rgb(245, 67, 89);
}
::ng-deep.warm-up-is .dotactions {
  position: relative;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner {
  position: absolute;
  top: 0;
  right: 0;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner--h {
  top: 5px;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner--h .dotactions__top {
  cursor: pointer;
  width: 17px;
  justify-content: space-between;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner--v {
  right: 10px;
  top: 11px;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner--v .dotactions__top {
  cursor: pointer;
  flex-direction: column;
  justify-content: space-between;
  height: 21px;
  width: 11px;
  align-items: center;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__top {
  padding-bottom: 4px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__top span {
  background-color: #adadad;
  width: 3px;
  height: 3px;
  border-radius: 50%;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__dropdown {
  display: none;
  background-color: #fff;
  position: absolute;
  top: 100%;
  width: 150px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);
  right: -5px;
  border-radius: 4px;
  z-index: 9;
  border: 1px solid #ddd;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__close {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 6px;
  font-size: 11px;
  transition: all ease 0.3s;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__close:hover {
  transform: rotate(360deg);
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  padding: 18px;
  background: #fff;
  border: 1px solid #ddd;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner .dotactions__dropdownin {
  padding: 10px 10px;
  border-radius: 4px;
  min-height: 100%;
  background-color: #f4f4f4;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner .dotactions__dropdownin select:focus {
  outline: #6d6e71;
  border: 0;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner .dotactions__dropdownin h6 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__dropdown > h6 {
  text-align: center;
  margin: 0;
  font-size: 13px;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
  font-weight: 400;
  margin-bottom: 2px;
  background-color: #f4f4f4;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__dropdown li {
  margin: 0;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__dropdown li a {
  padding: 6px 12px;
  color: #656565;
  display: block;
  font-weight: 400;
}
::ng-deep.warm-up-is .dotactions .dotactions__inner .dotactions__dropdown li a:hover {
  background-color: rgba(9, 30, 66, 0.04);
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap {
  padding: 4px 0 100px;
  overflow-x: auto;
  margin: 0 0 10px;
  display: flex;
  flex-wrap: nowrap;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .card-body__ipcol {
  padding: 0;
  margin-bottom: 0px;
  max-width: 270px;
  width: 100%;
  flex: 0 0 270px;
  -webkit-flex: 0 0 270px;
  -ms-flex: 0 0 270px;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .card-body__ipcol .checkbox {
  padding-right: 22px;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .card-body__ipcol + div {
  margin-left: 30px;
}
@media only screen and (max-width: 1080px) {
  ::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .card-body__ipcol {
    width: 50%;
  }
}
@media only screen and (max-width: 600px) {
  ::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .card-body__ipcol {
    width: 100%;
  }
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol > .form-control {
  width: calc(100% - 91px);
  border: 1px solid #ccc;
  border-radius: 4px 0 0 4px;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol .input-group-postpend {
  width: 90px;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol .input-group-postpend button {
  background-color: #27c24c;
  box-shadow: none;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap h2 {
  margin-top: 0;
  color: #656565;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap h2 label {
  display: inline-block;
  padding-right: 2px;
  width: auto !important;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox] {
  opacity: 0;
  position: absolute;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox] + span {
  position: relative;
  top: -2px;
  margin: 0 5px 0 0;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  text-align: center;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox] + span::before {
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox]:checked + span {
  background-color: #6d6e71;
  border-color: #6d6e71;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox]:checked + span::before {
  opacity: 1;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .dotactions__editinput {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div:first-child {
  margin-right: 10px;
  width: 77%;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div:first-child input:focus {
  border-color: #6d6e71;
  outline: #6d6e71;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div:nth-child(2) {
  margin-left: -5px;
  background-color: #7bbc43;
  padding: 3px 5px;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div:nth-child(3) {
  margin-left: 5px;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div i {
  font-size: 17px;
  color: rgb(255, 0, 0);
  cursor: pointer;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap ul {
  padding: 0;
  margin: 0;
  min-height: 10px;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap ul li {
  list-style: none;
  padding: 0;
  width: 100%;
}
::ng-deep.warm-up-is .card-body__ip .card-body__ipwrap ul li .card-body__ipinner {
  display: block;
  font-weight: 400;
  position: relative;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
}
::ng-deep.warm-up-is .cancelTool.tooltipicon {
  position: relative;
  font-size: 18px;
  display: inline-block;
  margin-left: 15px;
  cursor: pointer;
}
::ng-deep.warm-up-is .cancelTool.tooltipicon .tooltiptext {
  visibility: hidden;
  width: 150px;
  background-color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 6px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: -25px;
  left: 10px;
  z-index: 1;
}
::ng-deep.warm-up-is .cancelTool.tooltipicon:hover {
  color: #333;
}
::ng-deep.warm-up-is .cancelTool.tooltipicon:hover .tooltiptext {
  visibility: visible;
}

.launch-is {
  text-align: center;
  margin: 30px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}

.topstation__inner {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}
.topstation__inner > div {
  padding: 0 15px;
}
.topstation .topstation__cell {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.topstation .topstation__cell h3.topstation__savedone span {
  display: block;
}
.topstation .topstation__cell h3.topstation__savedone span:first-child {
  font-size: 0.8em;
}
.topstation label {
  padding-right: 15px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.topstation__input {
  flex-grow: 1;
}
.topstation__input input {
  height: 50px;
  padding: 10px 15px;
  border: 1px solid #CCC;
  border-radius: 4px;
  font-size: 15px;
  color: #555555;
}

.open-question i {
  font-size: 21px;
  color: #6d6e71;
  cursor: pointer;
}
.open-question i:not(:last-child) {
  margin-right: 10px;
}

.tooltippopup {
  max-width: 360px;
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  right: -400px;
  padding: 45px 24px 24px;
  text-align: left;
  z-index: 9999;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  transition: all ease 0.3s;
  overflow: hidden;
}
.tooltippopup--active {
  right: 0;
}
.tooltippopup__btn {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0 0 10px;
}
.tooltippopup__btn li {
  list-style: none;
  text-align: center;
  cursor: pointer;
  width: 33.3333333333%;
}
.tooltippopup__btn li button {
  width: 100%;
  color: #6d6e71;
  font-size: 12px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  border: 1px solid #6d6e71;
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
.tooltippopup__btn li button:focus {
  outline: none;
}
.tooltippopup__btn li button.tooltippopup__btncompleted {
  opacity: 0.2;
}
.tooltippopup__btn li button.tooltippopup__btncompleted:hover {
  opacity: 1;
}
.tooltippopup__btn li button.tooltippopup__btnactive {
  opacity: 1;
}
.tooltippopup__btn li button:hover {
  position: relative;
  z-index: 9;
}
.tooltippopup__btn li + li {
  margin-left: -1px;
}
.tooltippopup__btn li:first-child button {
  border-radius: 3px 0 0 3px;
}
.tooltippopup__btn li:last-child button {
  border-radius: 0 3px 3px 0;
}
.tooltippopup h4 {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 16px;
  line-height: 1.2;
}
.tooltippopup p {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.4;
}
.tooltippopup__close {
  position: absolute;
  top: 10px;
  right: 25px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: all ease 0.3s;
}
.tooltippopup__close:hover {
  transform: rotate(360deg);
}
.tooltippopup__close > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.tooltippopup__close > div span {
  position: absolute;
  background: #676a6c;
}
.tooltippopup__close > div span:nth-child(1) {
  top: 0;
  left: calc(50% - 1px);
  width: 2px;
  height: 100%;
}
.tooltippopup__close > div span:nth-child(2) {
  top: calc(50% - 1px);
  left: 0;
  width: 100%;
  height: 2px;
}
.tooltippopup__child {
  margin-top: 20px;
}
.tooltippopup__childdata h4 {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 2px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: #6d6e71;
}
.tooltippopup__childdata p {
  margin-bottom: 5px;
  line-height: 1.3;
}
.tooltippopup__childdata p:last-child {
  margin-bottom: 0;
}
.tooltippopup__childdata + div {
  margin-top: 17px;
}
.tooltippopup__links {
  padding: 0;
  margin: 0;
}
.tooltippopup__links li {
  list-style: none;
  width: 100%;
}
.tooltippopup__links li a {
  position: relative;
  color: #6d6e71;
  transition: all ease 0.3s;
}
.tooltippopup__links li a:hover {
  opacity: 0.75;
}
.tooltippopup__links li + li {
  margin-top: 4px;
}

.popaccordian__rowhead {
  position: relative;
  cursor: pointer;
  border: 1px solid #6d6e71;
  padding: 9px;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
}
.popaccordian__rowheadarrow {
  position: absolute;
  top: 0;
  left: 0;
}
.popaccordian__rowhead h5 {
  margin: 0;
  position: relative;
  color: #6d6e71;
  padding-left: 10px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowhead h5 i {
  transition: all ease 0.3s;
}
.popaccordian__rowbody {
  border: 1px solid #6d6e71;
  border-top: 0;
  display: none;
  border-radius: 0 0 3px 3px;
}
.popaccordian__rowbodyinner {
  padding: 10px;
}
.popaccordian__rowbodyinner > *:last-child {
  margin-bottom: 0;
}
.popaccordian__rowbodyinner h5 {
  margin: 0 0 10px;
  position: relative;
  color: #6d6e71;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowbodyinner ul {
  margin: 0;
  padding: 0;
}
.popaccordian__rowbodyinner ul li {
  list-style: none;
  font-size: 14px;
  line-height: 1.3;
  position: relative;
  padding-left: 10px;
}
.popaccordian__rowbodyinner ul li::before {
  content: "";
  position: absolute;
  top: 7px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
.popaccordian__rowbodyinner ul li + li {
  margin-top: 5px;
}
.popaccordian__row + div {
  margin-top: 15px;
}
.popaccordian__row--active .popaccordian__rowhead {
  border-radius: 3px 3px 0 0;
}
.popaccordian__row--active .popaccordian__rowhead i {
  transform: rotate(90deg);
}

.row {
  position: relative;
}
.row--editmodebg {
  background-color: #fff;
  padding: 40px 35px;
}
.row--wbg {
  background-color: #fff;
}

.editmode {
  margin-bottom: 30px;
}
.editmode--btinp {
  margin-bottom: 0px;
}
.editmode--sc h3 {
  color: #676A6C !important;
}
.editmode__listrow {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
}
.editmode__listrow--nogap {
  grid-gap: 0;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow {
    grid-template-columns: 1fr;
  }
}
.editmode__listrow--equalblocks {
  display: flex;
  flex-wrap: wrap;
}
.editmode__listrow--equalblocks > .editmode__listcol {
  flex: 1;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow--equalblocks > .editmode__listcol {
    flex: none;
    width: 100%;
  }
}
.editmode__listrow--fullblocks {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid1 {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid3 > div:nth-child(1) {
  grid-row: 1/3;
}
.editmode__listrow--grid4 > div:nth-child(1) {
  grid-row: 1/4;
}
.editmode__listrow--grid5 > div:nth-child(1) {
  grid-row: 1/5;
}
.editmode__listrow--grid6 > div:nth-child(1) {
  grid-row: 1/6;
}
.editmode__listrow--grid7 > div:nth-child(1) {
  grid-row: 1/7;
}
.editmode__listcell {
  padding: 10px 15px;
  background-color: #EBEBEB;
  border: 1px solid #CFDBE2;
  border-radius: 6px;
  height: 100%;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell {
    font-size: 13px;
  }
}
.editmode__listcell h3 {
  color: #6d6e71;
  margin-bottom: 5px;
}
.editmode__listcell h3 a,
.editmode__listcell h3 i {
  color: inherit;
}
.editmode__listcell--ls li {
  list-style-type: disc;
  color: #676a6c;
}
.editmode__listcell--sc p {
  font-weight: normal !important;
}
.editmode__listcell p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell p {
    font-size: 13px;
  }
}
.editmode__listcell p:last-child {
  margin-bottom: 0;
}

.Del-data-btn {
  padding: 40px 0;
}
.Del-data-btn .btn {
  margin-left: 15px;
  background-color: #fff;
  border-color: #f5f5f5;
  color: #ff485c;
}
.Del-data-btn .cancelbtn {
  color: #676a6c;
  text-align: center;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  padding: 6px;
}

.stick-challenge {
  position: relative;
}
.stick-challenge .card-body__inner {
  min-height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 9;
  position: relative;
}
.stick-challenge .card-body__inner .card-body__subtitle {
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: #fff;
}

.trackInfo {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}
.trackInfo--inputclr {
  color: #464646;
  font-size: 11px;
  background: transparent;
  margin-left: 8px;
  padding-left: 0;
  margin-bottom: 2px;
  display: inline-block;
}
.trackInfo--pos {
  position: absolute;
  top: -18px;
}

.cdk-drag-preview {
  border: 1px solid #ccc !important;
  padding: 10px;
}
.cdk-drag-preview .dotactions__inner {
  display: none;
}

span.thinkeyebtn {
  position: relative;
  width: 100%;
  display: inline-block;
  text-align: right;
  margin: 0px 0 6px;
  cursor: pointer;
}

::ng-deep .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
::ng-deep .modal.fade.in {
  opacity: 1;
}
::ng-deep .modal.in .modal-dialog {
  transform: translate(0, 0);
}
::ng-deep .modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  ::ng-deep .modal .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
}
::ng-deep .modal .modal-dialog .modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
::ng-deep .modal .modal-dialog .modal-content .close:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form .form-group {
  margin-bottom: 15px;
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
::ng-deep .modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--seagrn {
  border-color: #1dc5a3;
  background-color: #1dc5a3;
}
::ng-deep .modal .f-btn--seagrn:hover {
  border-color: #1dc5a3;
  background-color: #1dc5a3;
}
::ng-deep .modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
::ng-deep .modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
::ng-deep .modal .f-btn--wht {
  color: #ff485c;
  border-color: #f5f5f5;
  background-color: #fff;
}
::ng-deep .modal .f-btn--wht:hover {
  color: #ff485c;
  border-color: #f5f5f5;
  background-color: #fff;
}
::ng-deep .modal .f-btn--cncl {
  color: #676a6c;
  background-color: #fff;
  border: 1px solid #F6F5F7;
}
::ng-deep .modal .f-btn--cncl:hover {
  color: #676a6c;
  border: 1px solid #F6F5F7;
  background-color: #fff;
}
::ng-deep .modal .f-btn--info {
  color: #fff;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
::ng-deep .modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
::ng-deep .modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
::ng-deep .modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}

::ng-deep.modal-open {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/challenges/warm-up/warm-up.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAtYA;EACI,oCAAA;AAyYJ;;AAtYA;EACI,gBAAA;AAyYJ;;AApVA;EACI,oBAAA;AAuVJ;;AApVA;EACI,mBAAA;AAuVJ;;AAnVI;EAxDA,aAAA;EAEA,eAAA;EAkBA,uBAAA;EAuCI,mBAAA;AA4VR;AA1VQ;EACI,mBAAA;AA4VZ;AAxVoB;EACI,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AA0VxB;AAlVI;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAoVR;AAlVQ;EACI,aAAA;AAoVZ;AA/UY;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAiVhB;AA/UgB;EACI,WAAA;AAiVpB;AA9UgB;EACI,yBAAA;AAgVpB;AA1UQ;EACI,yBAhIG;AA4cf;AA1UY;EACI,iBAAA;AA4UhB;AA1UgB;EACI,eAAA;AA4UpB;AAvUQ;EACI,eAAA;EACA,SAAA;EDeV,mCAAA;EACA,8BAAA;AC2TF;AAxUY;EACI,WAAA;EACA,cAAA;AA0UhB;AAtUQ;EAxIJ,aAAA;EAEA,eAAA;EAYA,mBAAA;EA6HQ,eAAA;AA8UZ;AA5UY;EACI,eAAA;EACA,qBAAA;AA8UhB;AA5UgB;EACI,iBAAA;EACA,iBAAA;AA8UpB;AA3UgB;EAtJZ,aAAA;EAEA,eAAA;EAYA,mBAAA;AA6dJ;AAjVoB;EACI,kBAAA;AAmVxB;AA/UgB;EACI,UAAA;AAiVpB;AA9UgB;EAnKZ,aAAA;EAEA,eAAA;EAkBA,uBAAA;AAueJ;AApVoB;EAvKhB,aAAA;EAEA,eAAA;EAuKoB,SAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AA0VxB;AArVoC;EACI,uBAAA;AAuVxC;AAnVwC;EADJ;IAEQ,WAAA;EAsV1C;AACF;AA/UoC;EACI,sBAAA;AAiVxC;AA7UwC;EADJ;IAEQ,YAAA;EAgV1C;AACF;AA3U4B;EACI,iBAAA;AA6UhC;AAzUgC;EACI,kBAAA;AA2UpC;AAtUgC;EACI,cArOrB;EAsOqB,yBAAA;EACA,eAAA;AAwUpC;AAtUoC;EACI,cA1OzB;EA2OyB,yBAAA;AAwUxC;AAtUwC;EACI,yBAAA;EACA,WAAA;AAwU5C;AAjUgC;EACI,YAAA;EACA,yBAAA;EACA,cAzPrB;EA0PqB,eAAA;AAmUpC;AAjUoC;EACI,cA7PzB;EA8PyB,yBAAA;AAmUxC;AAjUwC;EACI,yBAAA;EACA,WAAA;AAmU5C;AA7T4B;EACI,kBAAA;EACA,wBDxPhB;ECyPgB,eAAA;EACA,iBAAA;EDhH9B,mCAAA;EACA,8BAAA;ECiH8B,qBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EAzO5B,yBAAA;EA6O4B,gBAAA;AAkUhC;AAhUgC;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;AAkUpC;AAhUoC;EACI,aA7RzB;AA+lBf;AA9TgC;EAzBJ;IA0BQ,gBAAA;IACA,eAAA;EAiUlC;AACF;AA/TgC;EACI,aAAA;EACA,gBAAA;AAiUpC;AA7ToC;EADJ;IAEQ,aAAA;EAgUtC;AACF;AA7TgC;EACI,aAAA;AA+TpC;AA7ToC;EAHJ;IAIQ,qBAAA;EAgUtC;AACF;AA7TgC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAhUrB;EAiUqB,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AA+TpC;AA7ToC;EAfJ;IAgBQ,kBAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EAgUtC;AACF;AA7TgC;EACI,cAlVrB;EAmVqB,UAAA;AA+TpC;AA5TgC;EACI,cAvVrB;EAwVqB,yBAAA;EACA,UAAA;AA8TpC;AArToB;EACI,cAnWT;EAoWS,iBAAA;AAuTxB;AAlTY;EACI,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EDlNd,mCAAA;EACA,8BAAA;ECmNc,cAhXD;EAiXC,eAAA;EAzUZ,yBAAA;EA2UY,eAAA;AAuThB;AArTgB;EAZJ;IAaQ,iBAAA;EAwTlB;AACF;AAtTgB;EACI,yBA1XL;EA2XK,WAAA;AAwTpB;AArTgB;EACI,aAAA;AAuTpB;AAnTY;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAqThB;AAnTgB;EACI,cA1YL;AA+rBf;AAlTgB;EACI,mBAAA;AAoTpB;AAjTgB;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,cArZL;EAsZK,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAmTpB;AA9SQ;EACI,eAAA;EACA,SAAA;EACA,eAAA;EACA,cAzaG;ED4Jb,mCAAA;EACA,8BAAA;EC/IE,aAAA;EAEA,eAAA;EAYA,mBAAA;AAusBJ;AArTY;EATJ;IAUQ,eAAA;EAwTd;AACF;AAtTY;EACI,eAAA;EACA,gBAAA;AAwThB;AAtTgB;EACI,iBAAA;AAwTpB;AAtToB;EACI,cAAA;EACA,gBAAA;AAwTxB;AApTgB;EACI,iBAAA;AAsTpB;AAlTY;EAGI,aAAA;AAoThB;AAlTgB;EACI,mBAAA;AAoTpB;AAhToB;EACI,cAAA;AAkTxB;AA5SQ;EACI,kBAAA;EACA,eAAA;EACA,qBAAA;AA8SZ;AA5SY;EACI,cA3dD;AAywBf;AA3SY;EACI,mBAAA;AA6ShB;AA1SY;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAteD;EAueC,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AA4ShB;AAvSI;EAiDI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,yCAAA;AAyPR;AA5SQ;EACI,gBAAA;AA8SZ;AA3SQ;EACI,SAAA;EACA,yBAAA;EACA,kBAAA;AA6SZ;AA3SY;EACI,6BAAA;EACA,4BAAA;AA6ShB;AA3SgB;EACI,yBArgBL;AAkzBf;AA1SwB;EACI,WAAA;AA4S5B;AAtSgC;EACI,kBAAA;EACA,sBAAA;AAwSpC;AAtSoC;EACI,cAphBzB;EAqhByB,sBAAA;AAwSxC;AArSoC;EACI,qBAAA;AAuSxC;AAhSoB;EACI,WAAA;AAkSxB;AAvRQ;EACI,kBAAA;AAyRZ;AAtRQ;EACI,aAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;AAwRZ;AAtRY;EACI,cAAA;AAwRhB;AAtRgB;EACI,sBAAA;AAwRpB;AAlRgB;EACI,eAAA;EACA,gBAAA;AAoRpB;AAlRoB;EACI,gBAAA;AAoRxB;AAhRgB;EA5jBZ,aAAA;EAEA,eAAA;EA4jBgB,eAAA;AAsRpB;AApRoB;EACI,UAAA;EACA,eAAA;AAsRxB;AApRwB;EAJJ;IAKQ,WAAA;EAuR1B;AACF;AArRwB;EACI,kBAAA;EACA,kBAAA;AAuR5B;AArR4B;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AAuRhC;AA9QY;EACI,eAAA;AAgRhB;AA7QY;EACI,UAAA;EACA,SAAA;AA+QhB;AA7QgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AA+QpB;AA7QoB;EACI,kBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AA+QxB;AA1QoB;EACI,qBA7oBT;AAy5Bf;AAzQoB;EACI,UAAA;AA2QxB;AArQQ;EACI,aAAA;AAuQZ;AArQY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAuQhB;AArQgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;AAuQpB;AApQgB;EACI,sBAAA;AAsQpB;AAlQY;EACI,UAAA;EACA,kBAAA;EACA,aAAA;AAoQhB;AAlQgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAoQpB;AAlQoB;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AAoQxB;AA/PoB;EACI,qBAhtBT;EAitBS,yBAjtBT;AAk9Bf;AA9PoB;EACI,UAAA;AAgQxB;AA1PQ;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;AA4PZ;AA1PY;EAltBR,aAAA;EAEA,eAAA;EAYA,mBAAA;AAw8BJ;AAhQgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EAhsBhB,yBAAA;AAq8BJ;AAlQoB;EACI,iBAAA;AAoQxB;AAjQoB;EACI,iBAAA;EACA,gBAAA;AAmQxB;AA/PgB;EACI,iBAAA;AAiQpB;AA9PgB;EACI,yBA1vBL;EA2vBK,qBA3vBL;EA4vBK,WAAA;EACA,gBAAA;AAgQpB;AA9PoB;EACI,kBAAA;AAgQxB;AA7PoB;EACI,yBApwBT;EAqwBS,qBArwBT;AAogCf;AA5PoB;EACI,iBAAA;AA8PxB;AA1PgB;EACI,yBAAA;EACA,qBAAA;AA4PpB;AA1PoB;EACI,yBAAA;EACA,qBAAA;AA4PxB;AAxPgB;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;AA0PpB;AAxPoB;EACI,yBAAA;EACA,qBAAA;AA0PxB;AArPoB;EACI,SAAA;AAuPxB;AAnPgB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EAvwBhB,yBAAA;EAywBgB,gBAAA;EACA,cAAA;AAuPpB;AArPoB;EACI,kBAAA;EACA,UAAA;EA9wBpB,yBAAA;AAwgCJ;AAtPoB;EACI,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAwPxB;AAtPwB;EACI,kBAAA;EACA,OAAA;AAwP5B;AArPwB;EACI,iBAAA;AAuP5B;AAnPoB;EAEI,eAAA;EApyBpB,yBAAA;AA2hCJ;AAhPQ;EACI,uBAAA;EACA,kCAAA;EACA,mBAAA;AAkPZ;AAhPY;EACI,uBDz0BA;AC2jChB;AA9OQ;EACI,uBD90BI;AC8jChB;AA7OQ;EACI,eAAA;AA+OZ;AA7OY;EACI,gBAAA;AA+OhB;AA3OQ;EACI,kBAAA;AA6OZ;AA3OY;;EAEI,WAAA;EACA,eAAA;EACA,kBAAA;AA6OhB;AA3OgB;;;;EAEI,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AA+OpB;AA3OY;EACI,eAAA;EA/2BZ,aAAA;EAEA,eAAA;AA+lCJ;AA/OgB;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AAiPpB;AA5OwB;EACI,aAAA;AA8O5B;AA1OoB;EACI,UAAA;AA4OxB;AAzOoB;EACI,kBAAA;AA2OxB;AAvOgB;EAGI,gBAAA;EACA,iFAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,wBAAA;AAyOpB;AAvOoB;EACI,aAAA;AAyOxB;AArOgB;EACI,WAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAuOpB;AApOgB;;EAh6BZ,aAAA;EAEA,eAAA;AA0oCJ;AAxOoB;;EACI,WAAA;EACA,mBAAA;EAt6BpB,aAAA;EAEA,eAAA;EAYA,mBAAA;AA2oCJ;AA9OoB;;EACI,WAAA;EACA,kBAAA;EA76BpB,aAAA;EAEA,eAAA;EAYA,mBAAA;EAMA,uBAAA;EA85BoB,eAAA;EACA,0BAAA;EACA,gBAAA;AAwPxB;AAtPwB;;EACI,wBAAA;AAyP5B;AAvP4B;;EACI,kBAAA;AA0PhC;AAxPgC;;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;EACA,cAh9BrB;AA2sCf;AAzPoC;;;EAEI,cAAA;AA4PxC;AAzPoC;;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AA4PxC;AAxPgC;;EACI,kBAAA;AA2PpC;AA/OoB;;EACI,YAAA;EACA,mBAAA;AAkPxB;AA/OoB;;EACI,yBAAA;AAkPxB;AAhPwB;;EACI,mBAAA;EACA,wBAAA;AAmP5B;AAjP4B;;EACI,aAAA;AAoPhC;AA/OoB;;EACI,WAAA;AAkPxB;AA5OgB;EACI,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EA1+BhB,yBAAA;EA4+BgB,eAAA;EACA,cAAA;EACA,gBAAA;AAgPpB;AA9OoB;EACI,yBAzhCT;EA0hCS,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAgPxB;AA1OQ;EACI,UAAA;EACA,qBAAA;EACA,kBAAA;AA4OZ;AAzOQ;EAQI,oBAAA;EArhCR,mBAAA;EAuhCQ,WAAA;EACA,gBAAA;EACA,SAAA;AAwOZ;AAnPY;EACI,kBAAA;EACA,SAAA;AAqPhB;AA1OY;EACI,YAAA;EACA,kBAAA;AA4OhB;AAzOY;;EAEI,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AA2OhB;AAxOY;EACI,WAAA;EACA,SAAA;AA0OhB;AAvOY;EACI,SAAA;AAyOhB;AAtOY;EACI,UAAA;EACA,iBAAA;AAwOhB;AApOQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EAGA,2BAAA;EA9jCR,yBAAA;AAuyCJ;AAtOY;EACI,yBA1mCD;EA2mCC,qBA3mCD;EA4mCC,WAAA;AAwOhB;AApOQ;EAGI,aAAA;EAEA,eAAA;EACA,sBAAA;AAsOZ;AApOY;EACI,UAAA;AAsOhB;AApOgB;EACI,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;AAsOpB;AApOoB;EAEI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AAqOxB;AAlOoB;EACI,WAAA;EACA,UAAA;AAoOxB;AA9NgB;EACI,WAAA;AAgOpB;AA5NY;EACI,kBAAA;EACA,kBAAA;AA8NhB;AA5NgB;EACI,0BAAA;EACA,6BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AA8NpB;AAxNI;EACI,aAAA;EACA,iBAAA;EAGA,aAAA;EAEA,eAAA;AA0NR;AAxNQ;EACI,UAAA;EACA,mBAAA;AA0NZ;AAtNI;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;EACA,mBAAA;AAwNR;AAtNQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;AAwNZ;AAtNY;EACI,WAAA;EACA,kBAAA;EAGA,aAAA;EAEA,eAAA;AAwNhB;AAtNgB;EACI,kBAAA;EACA,WAAA;AAwNpB;AAtNoB;EACI,uBAAA;EACA,qBAvtCT;EAwtCS,YAAA;EACA,UAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AAwNxB;AApNgB;EACI,wBAAA;EACA,YAAA;EACA,kCAAA;EACA,kCAAA;AAsNpB;AA/MQ;EACI,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EAGA,yBAAA;AAiNZ;AA/MY;EACI,YAAA;AAiNhB;AA9MY;EACI,gBAAA;AAgNhB;AA7MY;EACI,kCDnvCA;ACk8ChB;AA5MY;EACI,kCDtvCD;ACo8Cf;AA3MY;EACI,kCDxvCE;ACq8ClB;AAxMI;EACI,kBAAA;AA0MR;AAxMQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;AA0MZ;AAxMY;EACI,QAAA;AA0MhB;AAxMgB;EACI,eAAA;EACA,WAAA;EAGA,8BAAA;AA0MpB;AAtMY;EACI,WAAA;EACA,SAAA;AAwMhB;AAtMgB;EACI,eAAA;EAIA,sBAAA;EAGA,8BAAA;EACA,YAAA;EACA,WAAA;EAGA,mBAAA;AAwMpB;AApMY;EACI,mBAAA;EAGA,aAAA;EAEA,eAAA;AAsMhB;AApMgB;EACI,yBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAsMpB;AAlMY;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,wCAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;AAoMhB;AAlMgB;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EAGA,yBAAA;AAoMpB;AAlMoB;EAGI,yBAAA;AAoMxB;AAhMgB;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AAkMpB;AAhMoB;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAkMxB;AAhMwB;EACI,gBAz3Cb;EA03Ca,SAAA;AAkM5B;AA/LwB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAiM5B;AA5LgB;EACI,kBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AA8LpB;AA3LgB;EACI,SAAA;AA6LpB;AA3LoB;EACI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AA6LxB;AA3LwB;EACI,uCAAA;AA6L5B;AApLQ;EACI,oBAAA;EACA,gBAAA;EACA,gBAAA;EAGA,aAAA;EAEA,iBAAA;AAsLZ;AApLY;EACI,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AAsLhB;AApLgB;EACI,mBAAA;AAsLpB;AAnLgB;EACI,iBAAA;AAqLpB;AAlLgB;EAjBJ;IAkBQ,UAAA;EAqLlB;AACF;AAnLgB;EArBJ;IAsBQ,WAAA;EAsLlB;AACF;AApLgB;EAGI,aAAA;EAEA,eAAA;AAsLpB;AApLoB;EACI,wBAAA;EACA,sBAAA;EACA,0BAAA;AAsLxB;AAnLoB;EACI,WAAA;AAqLxB;AAnLwB;EACI,yBAAA;EACA,gBAAA;AAqL5B;AA/KY;EACI,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAiLhB;AA/KgB;EACI,qBAAA;EACA,kBAAA;EACA,sBAAA;AAiLpB;AA9KgB;EACI,UAAA;EACA,kBAAA;AAgLpB;AA9KoB;EACI,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AAgLxB;AA9KwB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AAgL5B;AA5KoB;EACI,yBAzgDT;EA0gDS,qBA1gDT;AAwrDf;AA3KoB;EACI,UAAA;AA6KxB;AAxKY;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;AA0KhB;AAxKgB;EACI,kBAAA;EACA,UAAA;AA0KpB;AAxKoB;EACI,qBAliDT;EAmiDS,gBAniDT;AA6sDf;AAtKgB;EACI,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAwKpB;AArKgB;EACI,gBAAA;AAuKpB;AAnKoB;EACI,eAAA;EACA,qBAAA;EACA,eAAA;AAqKxB;AAhKY;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AAkKhB;AAhKgB;EACI,gBAAA;EACA,UAAA;EACA,WAAA;AAkKpB;AAhKoB;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AAkKxB;AA3JI;EACI,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;AA6JR;AA3JQ;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;AA6JZ;AA1JQ;EACI,WAAA;AA4JZ;AA1JY;EACI,mBAAA;AA4JhB;;AAtJA;EACI,kBAAA;EACA,YAAA;ED59CF,mCAAA;EACA,8BAAA;ACsnDF;;AAtJI;EA/mDA,aAAA;EAEA,eAAA;EA+mDI,eAAA;AA6JR;AA3JQ;EACI,eAAA;AA6JZ;AAzJI;EACI,YAAA;EAznDJ,aAAA;EAEA,eAAA;EAYA,mBAAA;AA8wDJ;AA7JgB;EAKI,cAAA;AA2JpB;AA/JoB;EACI,gBAAA;AAiKxB;AAxJI;EACI,mBAAA;ED7/CN,mCAAA;EACA,8BAAA;ACwpDF;AAxJI;EAGI,YAAA;AA0JR;AAxJQ;EACI,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA0JZ;;AApJI;EACI,eAAA;EACA,cAhrDO;EAirDP,eAAA;AAuJR;AArJQ;EACI,kBAAA;AAuJZ;;AAlJA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,wCAAA;EA5pDA,yBAAA;EA8pDA,gBAAA;AAuJJ;AArJI;EACI,QAAA;AAuJR;AApJI;EA9rDA,aAAA;EAEA,eAAA;EA8rDI,UAAA;EACA,gBAAA;AA0JR;AAxJQ;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AA0JZ;AAxJY;EACI,WAAA;EACA,cAztDD;EA0tDC,eAAA;EACA,iBAAA;ED/jDd,mCAAA;EACA,8BAAA;ECgkDc,qBAAA;EACA,YAAA;EACA,SAAA;EACA,yBAAA;EACA,6BAAA;EACA,yBAAA;EA9qDZ,gBAAA;AA40DJ;AA3JgB;EACI,aAAA;AA6JpB;AA1JgB;EACI,YAAA;AA4JpB;AA1JoB;EACI,UAAA;AA4JxB;AAxJgB;EACI,UAAA;AA0JpB;AAvJgB;EACI,kBAAA;EACA,UAAA;AAyJpB;AArJY;EACI,iBAAA;AAuJhB;AAnJgB;EACI,0BAAA;AAqJpB;AAhJgB;EACI,0BAAA;AAkJpB;AA5II;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA8IR;AA3II;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA6IR;AA1II;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAzvDJ,yBAAA;AAw4DJ;AA5IQ;EAGI,yBAAA;AA8IZ;AA3IQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAGA,wBAAA;AA6IZ;AA3IY;EACI,kBAAA;EACA,mBAAA;AA6IhB;AA3IgB;EACI,MAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;AA6IpB;AA1IgB;EACI,oBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AA4IpB;AAtII;EACI,gBAAA;AAwIR;AArIY;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EDprDd,mCAAA;EACA,8BAAA;ECqrDc,cAl1DD;AA09Df;AArIY;EACI,kBAAA;EACA,gBAAA;AAuIhB;AArIgB;EACI,gBAAA;AAuIpB;AAnIY;EACI,gBAAA;AAqIhB;AAhII;EACI,UAAA;EACA,SAAA;AAkIR;AAhIQ;EACI,gBAAA;EACA,WAAA;AAkIZ;AAhIY;EACI,kBAAA;EACA,cA92DD;EAwCX,yBAAA;AA28DJ;AAhIgB;EACI,aAAA;AAkIpB;AA9HY;EACI,eAAA;AAgIhB;;AArHQ;EACI,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EA33DR,aAAA;EAEA,eAAA;AAs/DJ;AA1HY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AA4HhB;AAzHY;EACI,SAAA;EACA,kBAAA;EACA,cAr5DD;EAs5DC,kBAAA;ED1vDd,mCAAA;EACA,8BAAA;ACs3DF;AA1HgB;EAj3DZ,yBAAA;AAg/DJ;AAzHQ;EACI,yBAAA;EACA,aAAA;EACA,aAAA;EACA,0BAAA;AA2HZ;AAzHY;EACI,aAAA;AA2HhB;AAzHgB;EACI,gBAAA;AA2HpB;AAxHgB;EACI,gBAAA;EACA,kBAAA;EACA,cA/6DL;ED4Jb,mCAAA;EACA,8BAAA;AC84DF;AAxHgB;EACI,SAAA;EACA,UAAA;AA0HpB;AAxHoB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA0HxB;AAxHwB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AA0H5B;AAvHwB;EACI,eAAA;AAyH5B;AAlHQ;EACI,gBAAA;AAoHZ;AAhHY;EACI,0BAAA;AAkHhB;AAhHgB;EA/5DZ,wBAAA;AAohEJ;;AA5GA;EACI,kBAAA;AA+GJ;AA7GI;EACI,sBAAA;EACA,kBAAA;AA+GR;AA5GI;EACI,sBAAA;AA8GR;;AA1GA;EACI,mBAAA;AA6GJ;AA3GI;EACI,kBAAA;AA6GR;AAxGQ;EACI,yBAAA;AA0GZ;AApGQ;EACI,aAAA;EACA,qCAAA;EACA,cAAA;AAsGZ;AApGY;EACI,WAAA;AAsGhB;AAnGY;EATJ;IAUQ,0BAAA;EAsGd;AACF;AApGY;EACI,aAAA;EACA,eAAA;AAsGhB;AApGgB;EACI,OAAA;AAsGpB;AApGoB;EAHJ;IAIQ,UAAA;IACA,WAAA;EAuGtB;AACF;AAlGY;EACI,0BAAA;AAoGhB;AAhGgB;EACI,0BAAA;AAkGpB;AA7FoB;EACI,aAAA;AA+FxB;AAzFoB;EACI,aAAA;AA2FxB;AArFoB;EACI,aAAA;AAuFxB;AAjFoB;EACI,aAAA;AAmFxB;AA7EoB;EACI,aAAA;AA+ExB;AAzEQ;EACI,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AA2EZ;AAxEY;EARJ;IASQ,eAAA;EA2Ed;AACF;AAzEY;EACI,cAtlED;EAulEC,kBAAA;AA2EhB;AAzEgB;;EAEI,cAAA;AA2EpB;AAtEgB;EACI,qBAAA;EACA,cAAA;AAwEpB;AAnEgB;EACI,8BAAA;AAqEpB;AAjEY;EACI,eAAA;EACA,gBAAA;AAmEhB;AAjEgB;EAJJ;IAKQ,eAAA;EAoElB;AACF;AAlEgB;EACI,gBAAA;AAoEpB;;AA5DA;EACI,eAAA;AA+DJ;AA7DI;EACI,iBAAA;EAEA,sBAAA;EACA,qBAAA;EACA,cAAA;AA8DR;AA3DI;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;AA6DR;;AAzDA;EACI,kBAAA;AA4DJ;AA1DI;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AA4DR;AA1DQ;EACI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AA4DZ;;AAtDA;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;AAyDJ;AAvDI;EACI,cAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AAyDR;AAtDI;EACI,kBAAA;EACA,UAAA;AAwDR;;AApDA;EACI,iCAAA;EACA,aAAA;AAuDJ;AArDI;EACI,aAAA;AAuDR;;AAnDA;EACI,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAsDJ;;AAjDA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AAoDJ;AAlDI;EACI,yBAAA;AAoDR;AAjDI;EACI,oCAAA;AAmDR;AA/CQ;EACI,mCAAA;AAiDZ;AA9CQ;EACI,UAAA;AAgDZ;AA3CQ;EACI,0BAAA;AA6CZ;AAzCI;EACI,kBAAA;EACA,gBAAA;AA2CR;AAxCI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AA0CR;AAxCQ;EALJ;IAMQ,YAAA;IACA,iBAAA;EA2CV;AACF;AAzCQ;EACI,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AA2CZ;AAzCY;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AA2ChB;AAzCgB;EACI,aAAA;AA2CpB;AAvCY;EACI,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EAEA,gBAAA;AAyChB;AAlCoB;EACI,mBAAA;AAoCxB;AA7BI;EACI,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AA+BR;AA7BQ;EACI,qBAAA;EACA,yBAAA;AA+BZ;AA5BQ;EACI,qBAAA;EACA,yBAAA;AA8BZ;AA5BY;EACI,qBAAA;EACA,yBAAA;AA8BhB;AA1BQ;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;AA4BZ;AA1BY;EACI,qBAAA;EACA,yBAAA;AA4BhB;AAxBQ;EACI,cAAA;EACA,qBAAA;EACA,sBAAA;AA0BZ;AAxBY;EACI,cAAA;EACA,qBAAA;EACA,sBAAA;AA0BhB;AAtBQ;EACI,cAAA;EACA,sBAAA;EACA,yBAAA;AAwBZ;AAtBY;EACI,cAAA;EACA,yBAAA;EACA,sBAAA;AAwBhB;AApBQ;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;AAsBZ;AApBY;EACI,qBAAA;EACA,yBAAA;AAsBhB;AAlBQ;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;AAoBZ;AAlBY;EACI,qBAAA;EACA,yBAAA;AAoBhB;;AAdA;EACI,gBAAA;AAiBJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n$mq-pc: 'only screen and (max-width: 1200px)';\n$mq-md: 'only screen and (max-width: 991px)';\n$mq-sm: 'only screen and (max-width: 767px)';\n$mq-mobile: 'only screen and (max-width: 480px)';\n$fs-dark-grey: #6d6e71;\n\n\nlabel {\n    font-family: 'Open Sans', sans-serif;\n}\n\nli {\n    list-style: none;\n}\n\n@mixin fflex() {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n@mixin fflex-jcc() {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n@mixin fflex-aic() {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n@mixin fflex-jcc {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n@mixin transition-slow() {\n    -webkit-transition: all ease 0.3s;\n    -o-transition: all ease 0.3s;\n    transition: all ease 0.3s;\n}\n\n@mixin transition-none() {\n    -webkit-transition: none;\n    -o-transition: none;\n    transition: none;\n}\n\n@mixin appearance-none() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@mixin transRotate ($rotate) {\n    -webkit-transform: rotate($rotate);\n    -ms-transform: rotate($rotate);\n    transform: rotate($rotate);\n}\n\n::ng-deep#page-wrapper {\n    padding-bottom: 60px;\n}\n\n::ng-deep#wrapper {\n    overflow-x: initial;\n}\n\n::ng-deep.warm-up-is {\n    .mainnav {\n        @include fflex();\n        @include fflex-jcc();\n        margin: 30px 0 40px;\n\n        &.mainnav--bottom {\n            margin: 80px 0 70px;\n\n            ul {\n                li {\n                    a {\n                        padding: 12px 30px;\n                        font-family: 'Open Sans', sans-serif;\n                        font-weight: 700;\n                        font-size: 16px;\n                    }\n                }\n            }\n        }\n\n    }\n\n    .info {\n        color: #fff;\n        margin-bottom: 25px;\n        padding: 20px 40px;\n        border-radius: 6px;\n        width: 100%;\n\n        &-outer {\n            display: flex;\n            // flex-wrap: wrap;\n\n            &--rw {}\n\n            .info-right-icon {\n                width: 36px;\n                height: 36px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                background-color: #fff;\n                border-radius: 5px;\n                cursor: pointer;\n                margin-left: 10px;\n\n                svg {\n                    width: 40px;\n                }\n\n                &--bg {\n                    background-color: #6d6e71;\n                }\n            }\n        }\n\n\n        &.infotitle {\n            background-color: $fs-dark-grey;\n\n            &--editmode {\n                padding: 4px 40px;\n\n                h1 {\n                    font-size: 25px;\n                }\n            }\n        }\n\n        h1 {\n            font-size: 36px;\n            margin: 0;\n            @include headingfont();\n\n            small {\n                color: #fff;\n                font-size: 80%;\n            }\n        }\n\n        .card__toprow {\n            @include fflex();\n            @include fflex-aic();\n            margin: 0 -15px;\n\n            .card__topcol {\n                padding: 0 15px;\n                width: calc(100% / 3);\n\n                &.card__topcol--tt {\n                    margin-left: auto;\n                    text-align: right;\n                }\n\n                &.card__topcol--title {\n                    @include fflex();\n                    @include fflex-aic();\n\n                    &>div:first-child {\n                        margin-right: 15px;\n                    }\n                }\n\n                &.card__topcol--startexist {\n                    width: 65%;\n                }\n\n                &.card__topcol--tab {\n                    @include fflex();\n                    @include fflex-jcc();\n\n                    ul {\n                        @include fflex();\n                        margin: 0;\n                        padding: 0;\n                        border-radius: 3px;\n                        line-height: 1;\n\n                        li {\n                            &:first-child {\n                                button {\n                                    svg {\n                                        right: calc(100% + 1px)\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            left: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:last-child {\n                                button {\n                                    svg {\n                                        left: calc(100% + 1px);\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            right: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:not(:first-child) {\n                                margin-left: -1px;\n                            }\n\n                            &:only-child {\n                                button {\n                                    border-radius: 3px;\n                                }\n                            }\n\n                            &.card__topactive {\n                                button {\n                                    color: $fs-dark-grey;\n                                    border: 1px solid $fs-dark-grey;\n                                    cursor: pointer;\n\n                                    span.card__topcount {\n                                        color: $fs-dark-grey;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &.card__topcomplete {\n                                button {\n                                    opacity: 0.2;\n                                    border: 1px solid $fs-dark-grey;\n                                    color: $fs-dark-grey;\n                                    cursor: pointer;\n\n                                    span.card__topcount {\n                                        color: $fs-dark-grey;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            button {\n                                position: relative;\n                                color: $develop-color;\n                                font-size: 17px;\n                                padding: 6px 16px;\n                                @include headingfont();\n                                display: inline-block;\n                                height: 100%;\n                                border: 0;\n                                background-color: transparent;\n                                @include transition-slow();\n                                -webkit-appearance: none;\n                                -moz-appearance: none;\n                                appearance: none;\n\n                                svg {\n                                    position: absolute;\n                                    top: -1px;\n                                    height: calc(100% + 2px);\n\n                                    .st0 {\n                                        fill: $fs-dark-grey\n                                    }\n                                }\n\n                                @media #{$mq-md} {\n                                    padding: 4px 6px;\n                                    font-size: 13px;\n                                }\n\n                                &:focus {\n                                    outline: none;\n                                    box-shadow: none;\n                                }\n\n                                &>.card__topdesktext {\n                                    @media only screen and (max-width: 1180px) {\n                                        display: none;\n                                    }\n                                }\n\n                                &>.card__topmobiletext {\n                                    display: none;\n\n                                    @media only screen and (max-width: 1180px) {\n                                        display: inline-block;\n                                    }\n                                }\n\n                                &>span.card__topcount {\n                                    width: 16px;\n                                    height: 16px;\n                                    line-height: 16px;\n                                    display: inline-block;\n                                    text-align: center;\n                                    font-size: 0.5em;\n                                    background-color: $fs-dark-grey;\n                                    color: #fff;\n                                    margin-left: 4px;\n                                    border-radius: 50%;\n                                    vertical-align: bottom;\n                                    position: relative;\n                                    top: -1px;\n\n                                    @media only screen and (max-width: 630px) {\n                                        position: absolute;\n                                        top: auto;\n                                        bottom: -2px;\n                                        right: 0;\n                                        margin: 0;\n                                    }\n                                }\n\n                                &:hover {\n                                    color: $fs-dark-grey;\n                                    opacity: 1;\n                                }\n\n                                &:hover>span.card__topcount {\n                                    color: $fs-dark-grey;\n                                    background-color: #efefef;\n                                    opacity: 1;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                .card__bwnh3pencil {\n\n                    a {\n                        color: $fs-dark-grey;\n                        margin-left: 15px;\n                    }\n                }\n            }\n\n            .card__h3button {\n                border: 1px solid $fs-dark-grey;\n                background-color: transparent;\n                margin-left: 10px;\n                padding: 2px 26px;\n                border-radius: 3px;\n                @include headingfont();\n                color: $fs-dark-grey;\n                font-size: 22px;\n                @include transition-slow();\n                cursor: pointer;\n\n                @media #{$mq-pc} {\n                    padding: 2px 12px;\n                }\n\n                &:hover {\n                    background-color: $fs-dark-grey;\n                    color: #fff;\n                }\n\n                &:focus {\n                    outline: none;\n                }\n            }\n\n            .tooltipicon {\n                cursor: pointer;\n                position: relative;\n                font-size: 18px;\n                display: inline-block;\n\n                i {\n                    color: $fs-dark-grey;\n                }\n\n                &:hover>i>.tooltiptext {\n                    visibility: visible;\n                }\n\n                .tooltiptext {\n                    visibility: hidden;\n                    width: 250px;\n                    background-color: #fff;\n                    color: $fs-dark-grey;\n                    text-align: center;\n                    border-radius: 6px;\n                    padding: 10px;\n                    box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                    font-size: 13px;\n                    font-family: 'Open Sans', sans-serif;\n                    line-height: 1.5;\n                    position: absolute;\n                    top: 15px;\n                    right: 10px;\n                    z-index: 1;\n                }\n            }\n        }\n\n        h3 {\n            font-size: 22px;\n            margin: 0;\n            cursor: pointer;\n            color: $fs-dark-grey;\n            @include headingfont();\n            @include fflex();\n            @include fflex-aic();\n\n            @media #{$mq-pc} {\n                font-size: 19px;\n            }\n\n            i {\n                cursor: pointer;\n                font-size: 0.9em;\n\n                &+div {\n                    padding-left: 7px;\n\n                    span {\n                        display: block;\n                        font-size: 0.7em;\n                    }\n                }\n\n                &+span {\n                    padding-left: 7px;\n                }\n            }\n\n            &.d-flex {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n\n                div:first-child {\n                    padding-right: 10px;\n                }\n\n                div:nth-child(2) {\n                    span {\n                        display: block;\n                    }\n                }\n            }\n        }\n\n        .tooltipicon {\n            position: relative;\n            font-size: 18px;\n            display: inline-block;\n\n            i {\n                color: $fs-dark-grey;\n            }\n\n            &:hover>i>.tooltiptext {\n                visibility: visible;\n            }\n\n            .tooltiptext {\n                visibility: hidden;\n                width: 250px;\n                background-color: #fff;\n                color: $fs-dark-grey;\n                text-align: center;\n                border-radius: 6px;\n                padding: 10px;\n                box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                font-size: 13px;\n                font-family: 'Open Sans', sans-serif;\n                line-height: 1.5;\n                position: absolute;\n                top: 15px;\n                right: 10px;\n                z-index: 1;\n            }\n        }\n    }\n\n    .card-default {\n        &+div {\n            margin-top: 30px;\n        }\n\n        .info {\n            margin: 0;\n            border: 1px solid $fs-dark-grey;\n            border-radius: 6px;\n\n            &.card__headactive {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n\n                &--wc {\n                    background-color: $fs-dark-grey;\n\n                    .card__topcol {\n                        h3 {\n                            color: #fff;\n                        }\n\n                        ul {\n                            li {\n\n                                button {\n                                    border-color: #fff;\n                                    background-color: #fff;\n\n                                    span {\n                                        color: $fs-dark-grey;\n                                        background-color: #fff;\n                                    }\n\n                                    .st0 {\n                                        fill: #fff !important;\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    i {\n                        color: #fff;\n                    }\n                }\n            }\n        }\n\n        border-radius: 6px;\n        border-top-width: 3px;\n        border: 0;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n\n        .card-body__inner {\n            padding: 15px 40px;\n        }\n\n        .card-body {\n            display: none;\n            border: 1px solid #CFDBE2;\n            border-top: 0;\n            border-radius: 0 0 6px 6px;\n            overflow: hidden;\n\n            &.card-show {\n                display: block;\n\n                &__wbg {\n                    background-color: #fff;\n                }\n\n            }\n\n            &__finalstate {\n                p {\n                    font-size: 15px;\n                    font-weight: 600;\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n\n                &--2 {\n                    @include fflex();\n                    margin: 0 -10px;\n\n                    &>div {\n                        width: calc(100% / 2);\n                        padding: 0 10px;\n\n                        @media only screen and (max-width: 767px) {\n                            width: 100%;\n                        }\n\n                        p {\n                            position: relative;\n                            padding-left: 10px;\n\n                            &::before {\n                                content: \"\";\n                                position: absolute;\n                                top: 8px;\n                                left: 0;\n                                width: 5px;\n                                height: 5px;\n                                border-radius: 50%;\n                                background-color: #444;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .c-radio {\n            label {\n                padding-left: 0;\n            }\n\n            input {\n                opacity: 0;\n                margin: 0;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 50%;\n                    border: 1px solid #ccc;\n                    margin-right: 5px;\n                    text-align: center;\n\n                    &::before {\n                        position: absolute;\n                        color: #5D9CEC;\n                        opacity: 0;\n                        font-size: 11px;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $fs-dark-grey;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .checkbox {\n            margin-top: 0;\n\n            label {\n                min-height: 20px;\n                padding-left: 0;\n                margin-bottom: 0;\n                font-weight: 400;\n                cursor: pointer;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 1px;\n                    margin-right: 6px;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                position: absolute;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 2px;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        font-size: 12px;\n                        position: absolute;\n                        color: #fff;\n                        opacity: 0;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $fs-dark-grey;\n                        background-color: $fs-dark-grey;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .card-body__button {\n            background-color: #f5f5f5;\n            border-top: 1px solid #e3e3e3;\n            padding: 12px 40px;\n\n            .card-button {\n                @include fflex();\n                @include fflex-aic();\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    text-align: center;\n                    @include transition-slow();\n\n                    &+.btn {\n                        margin-left: 15px;\n                    }\n\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n                }\n\n                .float-right {\n                    margin-left: auto;\n                }\n\n                .btn-warm {\n                    background-color: $fs-dark-grey;\n                    border-color: $fs-dark-grey;\n                    color: #fff;\n                    font-weight: 700;\n\n                    &--mr {\n                        margin-right: 10px;\n                    }\n\n                    &:hover {\n                        background-color: $fs-dark-grey;\n                        border-color: $fs-dark-grey;\n                    }\n\n                    i {\n                        margin-right: 8px;\n                    }\n                }\n\n                .btn-success {\n                    background-color: #27c24c;\n                    border-color: #27c24c;\n\n                    &:hover {\n                        background-color: #21A240;\n                        border-color: #1E983B;\n                    }\n                }\n\n                .btn-danger {\n                    background-color: #fff;\n                    border-color: #fff;\n                    color: #ef6272;\n\n                    &:hover {\n                        background-color: #ED2D2D;\n                        border-color: #EC2121;\n                    }\n                }\n\n                .btn-warning {\n                    em {\n                        margin: 0;\n                    }\n                }\n\n                .btn-deleteall {\n                    border: 0;\n                    background-color: transparent;\n                    position: relative;\n                    overflow: hidden;\n                    box-shadow: none;\n                    padding-right: 0;\n                    padding-left: 0;\n                    @include transition-slow();\n                    font-weight: 700;\n                    color: #6D6E71;\n\n                    span {\n                        position: absolute;\n                        left: 110%;\n                        @include transition-slow();\n                    }\n\n                    &:hover {\n                        background-color: #fff;\n                        color: #ed5562;\n                        padding-right: 16px;\n                        padding-left: 16px;\n\n                        &>span {\n                            position: relative;\n                            left: 0;\n                        }\n\n                        i {\n                            margin-right: 6px;\n                        }\n                    }\n\n                    i {\n                        // font-size: 1em;\n                        margin-right: 0;\n                        @include transition-slow();\n                    }\n                }\n            }\n        }\n\n        .note-3 {\n            padding: 15px 15px 10px;\n            border: 2px solid $clarify-color;\n            margin-bottom: 15px;\n\n            label {\n                color: $clarify-color;\n            }\n        }\n\n        .footer-line {\n            color: $clarify-color;\n        }\n\n        p {\n            font-size: 15px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n\n        .card-body__edit {\n            position: relative;\n\n            .breakthrough-input-tabs,\n            .datadump-input-tabs {\n                width: 100%;\n                margin-right: 0;\n                position: relative;\n\n                input,\n                select {\n                    height: 50px;\n                    padding: 10px 15px;\n                    border: 1px solid $color-neutral-mid;\n                    border-radius: 4px;\n                    font-size: 15px;\n                }\n            }\n\n            .card-body__editrow {\n                margin: 0 -15px;\n                @include fflex();\n\n                &>div {\n                    padding: 0 15px;\n                    width: 100%;\n                    margin-bottom: 15px;\n\n\n                    .card-body__editcol {\n\n                        &.hideblk {\n                            display: none;\n                        }\n                    }\n\n                    &.card-body__editcol--2 {\n                        width: calc(100% / 2);\n                    }\n\n                    &>div {\n                        position: relative;\n                    }\n                }\n\n                select {\n                    -webkit-appearance: none;\n                    -moz-appearance: none;\n                    appearance: none;\n                    background-image: url($assets+'/images/select.png');\n                    background-size: 10px;\n                    background-position: right 10px center;\n                    background-repeat: no-repeat;\n                    font-family: 'Open Sans';\n\n                    &:focus {\n                        outline: none;\n                    }\n                }\n\n                textarea {\n                    width: 100%;\n                    border: 1px solid $color-neutral-mid;\n                    resize: none;\n                    border-radius: 3px;\n                    padding: 10px 15px;\n                    font-size: 15px;\n                }\n\n                .breakthrough-input-tabs,\n                .breakthrough-input-tabs {\n                    @include fflex();\n\n                    &>.card-body__editlabel {\n                        width: 35px;\n                        padding-right: 15px;\n                        @include fflex();\n                        @include fflex-aic();\n                    }\n\n                    &>.card-body__editnumber {\n                        width: 40px;\n                        text-align: center;\n                        @include fflex();\n                        @include fflex-aic();\n                        @include fflex-jcc;\n                        // border: 1px solid $color-neutral-mid;\n                        border-right: 0;\n                        border-radius: 4px 0 0 4px;\n                        font-weight: 700;\n\n                        &+.card-body__editinput {\n                            width: calc(100% - 41px);\n\n                            &--ce {\n                                position: relative;\n\n                                .converge-icon {\n                                    position: absolute;\n                                    top: 50%;\n                                    transform: translateY(-50%);\n                                    left: 7px;\n                                    font-size: 26px;\n                                    color: $fs-dark-grey;\n\n                                    &:hover>.card-body__tooltip,\n                                    &:active>.card-body__tooltip {\n                                        display: block;\n                                    }\n\n                                    .card-body__tooltip {\n                                        display: none;\n                                        font-size: 16px;\n                                        color: #676a6c;\n                                        position: absolute;\n                                        bottom: 100%;\n                                        left: 0;\n                                        background: #fff;\n                                        padding: 5px;\n                                        border-radius: 5px;\n                                        box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                        width: max-content;\n                                    }\n                                }\n\n                                input {\n                                    padding-left: 26px;\n                                }\n\n                            }\n\n                            // input {\n                            //     border-top-left-radius: 0;\n                            //     border-bottom-left-radius: 0;\n                            // }\n                        }\n                    }\n\n                    &>.card-body__editselect {\n                        width: 315px;\n                        padding-right: 15px;\n                    }\n\n                    &>.card-body__editinput {\n                        width: calc(100% - 351px);\n\n                        input {\n                            padding-right: 70px;\n                            font-family: 'Open Sans';\n\n                            &:focus {\n                                outline: none;\n                            }\n                        }\n                    }\n\n                    &>.card-body__editinput:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n\n            &+.card-body__addnew {\n                button {\n                    font-size: 14px;\n                    font-weight: bold;\n                    background-color: transparent;\n                    border: 1px solid transparent;\n                    padding-right: 0;\n                    padding-left: 0;\n                    @include transition-slow();\n                    cursor: pointer;\n                    color: #6d6e71;\n                    font-weight: 700;\n\n                    &:hover {\n                        background-color: $fs-dark-grey;\n                        border: 1px solid $fs-dark-grey;\n                        color: #fff;\n                        padding-right: 12px;\n                        padding-left: 12px;\n                    }\n                }\n            }\n        }\n\n        .breakthrough-input-tabs {\n            width: 90%;\n            display: inline-block;\n            margin-right: 20px;\n        }\n\n        .input-tabs {\n            &+i {\n                position: relative;\n                top: -1px;\n            }\n\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            @include fflex-aic();\n            width: calc(100%);\n            padding: 0 0 0 0;\n            margin: 0;\n\n            .select_faded {\n                opacity: 0.2;\n                padding-left: 32px;\n            }\n\n            input,\n            select {\n                height: 50px;\n                padding: 10px 15px;\n                border: 1px solid #e3e3e3;\n                border-radius: 4px;\n                margin: 7px 0px;\n            }\n\n            label {\n                width: 20px;\n                margin: 0;\n            }\n\n            select {\n                width: 9%;\n            }\n\n            input {\n                width: 90%;\n                margin-left: 15px;\n            }\n        }\n\n        .input-group-text {\n            cursor: pointer;\n            padding: 3px 16px;\n            margin-bottom: 0;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 1.528571429;\n            color: #495057;\n            text-align: center;\n            white-space: nowrap;\n            background-color: #E9ECEF;\n            border: 1px solid #DDE6E9;\n            border-radius: 0.25rem;\n            position: absolute;\n            top: calc(50% + 1px);\n            right: 12px;\n            -webkit-transform: translateY(-50%);\n            -ms-transform: translateY(-50%);\n            transform: translateY(-50%);\n            @include transition-slow();\n\n            &:hover {\n                background-color: $fs-dark-grey;\n                border-color: $fs-dark-grey;\n                color: #fff;\n            }\n        }\n\n        .list-columns {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n            counter-reset: section;\n\n            &>div {\n                width: 50%;\n\n                &.card__body--cswrapper {\n                    width: 100%;\n                    position: relative;\n                    border-bottom: 1px solid #e4e4e4;\n                    padding-bottom: 5px;\n                    margin-bottom: 10px;\n\n                    &::before,\n                    &::after {\n                        content: \"\";\n                        position: absolute;\n                        bottom: -1px;\n                        right: calc(100%);\n                        width: 40px;\n                        height: 1px;\n                        background-color: #e4e4e4;\n                    }\n\n                    &::after {\n                        right: auto;\n                        left: calc(100%);\n                    }\n                }\n            }\n\n            &.list-columns--2 {\n                &>div {\n                    width: 100%;\n                }\n            }\n\n            .brainstorm-tabs {\n                position: relative;\n                padding-left: 23px;\n\n                &::before {\n                    counter-increment: section;\n                    content: counter(section) \".\";\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                }\n            }\n        }\n    }\n\n    .idea-shop-list {\n        padding: 20px;\n        margin-left: 17px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n\n        li {\n            width: calc(100% / 2);\n            margin-bottom: 10px;\n        }\n    }\n\n    .brainstorm__col {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        margin-bottom: 17px;\n\n        .brainstorm-main {\n            width: calc(100% - 68px);\n            display: inline-block;\n            margin-right: 20px;\n\n            .brainstorm-group {\n                width: 100%;\n                position: relative;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                .input-group-prepend {\n                    margin-right: -1px;\n                    width: 45px;\n\n                    .input-group-text {\n                        background: transparent;\n                        border-color: $fs-dark-grey;\n                        height: 35px;\n                        padding: 0;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        align-items: center;\n                        -webkit-box-pack: center;\n                        -ms-flex-pack: center;\n                        justify-content: center;\n                    }\n                }\n\n                input {\n                    width: calc(100% - 45px);\n                    height: 35px;\n                    border: 1px solid $ideate-color;\n                    border-radius: 0 0.25rem 0.25rem 0;\n                }\n            }\n        }\n    }\n\n    .card-bottom-button {\n        .button {\n            font-size: 13px;\n            color: #fff;\n            padding: 8px 10px;\n            border-radius: 3px;\n            -webkit-transition: all ease 0.3s;\n            -o-transition: all ease 0.3s;\n            transition: all ease 0.3s;\n\n            &:hover {\n                opacity: .8;\n            }\n\n            i {\n                font-size: 0.8em;\n            }\n\n            &.btn-clarify {\n                background-color: $clarify-color;\n            }\n\n            &.btn-ideate {\n                background-color: $ideate-color;\n            }\n\n            &.btn-implement {\n                background-color: $implement-color;\n            }\n        }\n    }\n\n    .dotactions {\n        position: relative;\n\n        .dotactions__inner {\n            position: absolute;\n            top: 0;\n            right: 0;\n\n            &--h {\n                top: 5px;\n\n                .dotactions__top {\n                    cursor: pointer;\n                    width: 17px;\n                    -webkit-box-pack: justify;\n                    -ms-flex-pack: justify;\n                    justify-content: space-between;\n                }\n            }\n\n            &--v {\n                right: 10px;\n                top: 11px;\n\n                .dotactions__top {\n                    cursor: pointer;\n                    -webkit-box-orient: vertical;\n                    -webkit-box-direction: normal;\n                    -ms-flex-direction: column;\n                    flex-direction: column;\n                    -webkit-box-pack: justify;\n                    -ms-flex-pack: justify;\n                    justify-content: space-between;\n                    height: 21px;\n                    width: 11px;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    align-items: center;\n                }\n            }\n\n            .dotactions__top {\n                padding-bottom: 4px;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                span {\n                    background-color: #adadad;\n                    width: 3px;\n                    height: 3px;\n                    border-radius: 50%;\n                }\n            }\n\n            .dotactions__dropdown {\n                display: none;\n                background-color: #fff;\n                position: absolute;\n                top: 100%;\n                width: 150px;\n                box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);\n                right: -5px;\n                border-radius: 4px;\n                z-index: 9;\n                border: 1px solid #ddd;\n\n                .dotactions__close {\n                    cursor: pointer;\n                    position: absolute;\n                    top: 5px;\n                    right: 6px;\n                    font-size: 11px;\n                    -webkit-transition: all ease 0.3s;\n                    -o-transition: all ease 0.3s;\n                    transition: all ease 0.3s;\n\n                    &:hover {\n                        -webkit-transform: rotate(360deg);\n                        -ms-transform: rotate(360deg);\n                        transform: rotate(360deg);\n                    }\n                }\n\n                .dotactions__dropdowninner {\n                    display: none;\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    width: 200px;\n                    box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);\n                    border-radius: 4px;\n                    padding: 18px;\n                    background: #fff;\n                    border: 1px solid #ddd;\n\n                    .dotactions__dropdownin {\n                        padding: 10px 10px;\n                        border-radius: 4px;\n                        min-height: 100%;\n                        background-color: #f4f4f4;\n\n                        select:focus {\n                            outline: $fs-dark-grey;\n                            border: 0;\n                        }\n\n                        h6 {\n                            margin: 0;\n                            font-size: 13px;\n                            font-weight: 600;\n                            margin-bottom: 6px;\n                        }\n                    }\n                }\n\n                &>h6 {\n                    text-align: center;\n                    margin: 0;\n                    font-size: 13px;\n                    padding: 8px 10px;\n                    border-bottom: 1px solid #eee;\n                    font-weight: 400;\n                    margin-bottom: 2px;\n                    background-color: #f4f4f4;\n                }\n\n                li {\n                    margin: 0;\n\n                    a {\n                        padding: 6px 12px;\n                        color: #656565;\n                        display: block;\n                        font-weight: 400;\n\n                        &:hover {\n                            background-color: rgba(9, 30, 66, .04);\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .card-body__ip {\n        .card-body__ipwrap {\n            padding: 4px 0 100px;\n            overflow-x: auto;\n            margin: 0 0 10px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-wrap: nowrap;\n            flex-wrap: nowrap;\n\n            .card-body__ipcol {\n                padding: 0;\n                margin-bottom: 0px;\n                max-width: 270px;\n                width: 100%;\n                flex: 0 0 270px;\n                -webkit-flex: 0 0 270px;\n                -ms-flex: 0 0 270px;\n\n                .checkbox {\n                    padding-right: 22px;\n                }\n\n                &+div {\n                    margin-left: 30px;\n                }\n\n                @media only screen and (max-width: 1080px) {\n                    width: calc(100% / 2);\n                }\n\n                @media only screen and (max-width: 600px) {\n                    width: calc(100%);\n                }\n\n                .card-body__ipaddcol {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    -ms-flex-wrap: wrap;\n                    flex-wrap: wrap;\n\n                    &>.form-control {\n                        width: calc(100% - 91px);\n                        border: 1px solid #ccc;\n                        border-radius: 4px 0 0 4px;\n                    }\n\n                    .input-group-postpend {\n                        width: 90px;\n\n                        button {\n                            background-color: #27c24c;\n                            box-shadow: none;\n                        }\n                    }\n                }\n            }\n\n            h2 {\n                margin-top: 0;\n                color: #656565;\n                font-size: 14px;\n                font-weight: 500;\n                margin-bottom: 12px;\n\n                label {\n                    display: inline-block;\n                    padding-right: 2px;\n                    width: auto !important;\n                }\n\n                input[type=\"checkbox\"] {\n                    opacity: 0;\n                    position: absolute;\n\n                    &+span {\n                        position: relative;\n                        top: -2px;\n                        margin: 0 5px 0 0;\n                        display: inline-block;\n                        vertical-align: top;\n                        width: 20px;\n                        height: 20px;\n                        border-radius: 2px;\n                        border: 1px solid #ccc;\n                        text-align: center;\n\n                        &::before {\n                            position: absolute;\n                            color: #fff;\n                            opacity: 0;\n                            top: 50%;\n                            left: 50%;\n                            -webkit-transform: translate(-50%, -50%);\n                            -ms-transform: translate(-50%, -50%);\n                            transform: translate(-50%, -50%);\n                        }\n                    }\n\n                    &:checked+span {\n                        background-color: $fs-dark-grey;\n                        border-color: $fs-dark-grey;\n                    }\n\n                    &:checked+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n\n            .dotactions__editinput {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n\n                &>div:first-child {\n                    margin-right: 10px;\n                    width: 77%;\n\n                    input:focus {\n                        border-color: $fs-dark-grey;\n                        outline: $fs-dark-grey;\n                    }\n                }\n\n                &>div:nth-child(2) {\n                    margin-left: -5px;\n                    background-color: #7bbc43;\n                    padding: 3px 5px;\n                    font-size: 12px;\n                    color: #fff;\n                    cursor: pointer;\n                }\n\n                &>div:nth-child(3) {\n                    margin-left: 5px;\n                }\n\n                &>div {\n                    i {\n                        font-size: 17px;\n                        color: rgb(255, 0, 0);\n                        cursor: pointer;\n                    }\n                }\n            }\n\n            ul {\n                padding: 0;\n                margin: 0;\n                min-height: 10px;\n\n                li {\n                    list-style: none;\n                    padding: 0;\n                    width: 100%;\n\n                    .card-body__ipinner {\n                        display: block;\n                        font-weight: 400;\n                        position: relative;\n                        border: 1px solid #ccc;\n                        padding: 10px;\n                        border-radius: 5px;\n                    }\n                }\n            }\n        }\n    }\n\n    .cancelTool.tooltipicon {\n        position: relative;\n        font-size: 18px;\n        display: inline-block;\n        margin-left: 15px;\n        cursor: pointer;\n\n        .tooltiptext {\n            visibility: hidden;\n            width: 150px;\n            background-color: #fff;\n            text-align: center;\n            border-radius: 6px;\n            padding: 6px;\n            box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n            font-size: 13px;\n            font-family: 'Open Sans', sans-serif;\n            line-height: 1.5;\n            position: absolute;\n            top: -25px;\n            left: 10px;\n            z-index: 1;\n        }\n\n        &:hover {\n            color: #333;\n\n            .tooltiptext {\n                visibility: visible;\n            }\n        }\n    }\n}\n\n.launch-is {\n    text-align: center;\n    margin: 30px;\n    @include headingfont();\n}\n\n.topstation {\n    &__inner {\n        @include fflex();\n        margin: 0 -15px;\n\n        &>div {\n            padding: 0 15px;\n        }\n    }\n\n    .topstation__cell {\n        height: 100%;\n        @include fflex();\n        @include fflex-aic();\n\n        h3 {\n            &.topstation__savedone {\n                span {\n                    &:first-child {\n                        font-size: 0.8em;\n                    }\n\n                    display: block;\n                }\n            }\n        }\n    }\n\n    label {\n        padding-right: 15px;\n        @include headingfont();\n    }\n\n    &__input {\n        -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n\n        input {\n            height: 50px;\n            padding: 10px 15px;\n            border: 1px solid #CCC;\n            border-radius: 4px;\n            font-size: 15px;\n            color: #555555;\n        }\n    }\n}\n\n.open-question {\n    i {\n        font-size: 21px;\n        color: $fs-dark-grey;\n        cursor: pointer;\n\n        &:not(:last-child) {\n            margin-right: 10px;\n        }\n    }\n}\n\n.tooltippopup {\n    max-width: 360px;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    position: fixed;\n    top: 0;\n    right: -400px;\n    padding: 45px 24px 24px;\n    text-align: left;\n    z-index: 9999;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);\n    @include transition-slow();\n    overflow: hidden;\n\n    &--active {\n        right: 0;\n    }\n\n    &__btn {\n        @include fflex();\n        padding: 0;\n        margin: 0 0 10px;\n\n        li {\n            list-style: none;\n            text-align: center;\n            cursor: pointer;\n            width: calc(100% / 3);\n\n            button {\n                width: 100%;\n                color: $fs-dark-grey;\n                font-size: 12px;\n                padding: 6px 16px;\n                @include headingfont();\n                display: inline-block;\n                height: 100%;\n                border: 0;\n                border: 1px solid $fs-dark-grey;\n                background-color: transparent;\n                transition: all ease 0.3s;\n                @include appearance-none();\n\n                &:focus {\n                    outline: none;\n                }\n\n                &.tooltippopup__btncompleted {\n                    opacity: 0.2;\n\n                    &:hover {\n                        opacity: 1;\n                    }\n                }\n\n                &.tooltippopup__btnactive {\n                    opacity: 1;\n                }\n\n                &:hover {\n                    position: relative;\n                    z-index: 9;\n                }\n            }\n\n            &+li {\n                margin-left: -1px;\n            }\n\n            &:first-child {\n                button {\n                    border-radius: 3px 0 0 3px\n                }\n            }\n\n            &:last-child {\n                button {\n                    border-radius: 0 3px 3px 0;\n                }\n            }\n        }\n    }\n\n    h4 {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 16px;\n        line-height: 1.2;\n    }\n\n    p {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 14px;\n        line-height: 1.4;\n    }\n\n    &__close {\n        position: absolute;\n        top: 10px;\n        right: 25px;\n        width: 18px;\n        height: 18px;\n        cursor: pointer;\n        @include transition-slow();\n\n        &:hover {\n            -webkit-transform: rotate(360deg);\n            -ms-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n\n        &>div {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            -webkit-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: rotate(45deg);\n\n            span {\n                position: absolute;\n                background: #676a6c;\n\n                &:nth-child(1) {\n                    top: 0;\n                    left: calc(50% - 1px);\n                    width: 2px;\n                    height: 100%;\n                }\n\n                &:nth-child(2) {\n                    top: calc(50% - 1px);\n                    left: 0;\n                    width: 100%;\n                    height: 2px;\n                }\n            }\n        }\n    }\n\n    &__child {\n        margin-top: 20px;\n\n        &data {\n            h4 {\n                font-size: 16px;\n                font-weight: 500;\n                margin: 0 0 2px;\n                @include headingfont();\n                color: $fs-dark-grey;\n            }\n\n            p {\n                margin-bottom: 5px;\n                line-height: 1.3;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n\n            &+div {\n                margin-top: 17px;\n            }\n        }\n    }\n\n    &__links {\n        padding: 0;\n        margin: 0;\n\n        li {\n            list-style: none;\n            width: 100%;\n\n            a {\n                position: relative;\n                color: $fs-dark-grey;\n                @include transition-slow();\n\n                &::before {}\n\n                &:hover {\n                    opacity: 0.75;\n                }\n            }\n\n            &+li {\n                margin-top: 4px;\n\n            }\n        }\n    }\n}\n\n\n\n.popaccordian {\n    &__row {\n        &head {\n            position: relative;\n            cursor: pointer;\n            border: 1px solid $fs-dark-grey;\n            padding: 9px;\n            border-radius: 3px;\n            @include fflex();\n\n            &arrow {\n                position: absolute;\n                top: 0;\n                left: 0;\n            }\n\n            h5 {\n                margin: 0;\n                position: relative;\n                color: $fs-dark-grey;\n                padding-left: 10px;\n                @include headingfont();\n\n                i {\n                    @include transition-slow();\n                }\n            }\n        }\n\n        &body {\n            border: 1px solid $fs-dark-grey;\n            border-top: 0;\n            display: none;\n            border-radius: 0 0 3px 3px;\n\n            &inner {\n                padding: 10px;\n\n                &>*:last-child {\n                    margin-bottom: 0;\n                }\n\n                h5 {\n                    margin: 0 0 10px;\n                    position: relative;\n                    color: $fs-dark-grey;\n                    @include headingfont();\n                }\n\n                ul {\n                    margin: 0;\n                    padding: 0;\n\n                    li {\n                        list-style: none;\n                        font-size: 14px;\n                        line-height: 1.3;\n                        position: relative;\n                        padding-left: 10px;\n\n                        &::before {\n                            content: \"\";\n                            position: absolute;\n                            top: 7px;\n                            left: 0;\n                            width: 5px;\n                            height: 5px;\n                            border-radius: 50%;\n                            background-color: #444;\n                        }\n\n                        &+li {\n                            margin-top: 5px;\n                        }\n                    }\n                }\n            }\n        }\n\n        &+div {\n            margin-top: 15px;\n        }\n\n        &--active {\n            .popaccordian__rowhead {\n                border-radius: 3px 3px 0 0;\n\n                i {\n                    @include transRotate (90deg);\n                }\n            }\n        }\n    }\n\n}\n\n.row {\n    position: relative;\n\n    &--editmodebg {\n        background-color: #fff;\n        padding: 40px 35px;\n    }\n\n    &--wbg {\n        background-color: #fff;\n    }\n}\n\n.editmode {\n    margin-bottom: 30px;\n\n    &--btinp {\n        margin-bottom: 0px;\n    }\n\n    &--sc {\n\n        h3 {\n            color: #676A6C !important;\n        }\n    }\n\n    &__list {\n\n        &row {\n            display: grid;\n            grid-template-columns: repeat(2, 1fr);\n            grid-gap: 15px;\n\n            &--nogap {\n                grid-gap: 0;\n            }\n\n            @media #{$mq-sm} {\n                grid-template-columns: 1fr;\n            }\n\n            &--equalblocks {\n                display: flex;\n                flex-wrap: wrap;\n\n                &>.editmode__listcol {\n                    flex: 1;\n\n                    @media #{$mq-sm} {\n                        flex: none;\n                        width: 100%;\n                    }\n                }\n\n            }\n\n            &--fullblocks {\n                grid-template-columns: 1fr;\n            }\n\n            &--grid {\n                &1 {\n                    grid-template-columns: 1fr;\n                }\n\n                &3 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 3;\n                    }\n                }\n\n                &4 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 4;\n                    }\n                }\n\n                &5 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 5;\n                    }\n                }\n\n                &6 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 6;\n                    }\n                }\n\n                &7 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 7;\n                    }\n                }\n            }\n        }\n\n        &cell {\n            padding: 10px 15px;\n            background-color: #EBEBEB;\n            border: 1px solid #CFDBE2;\n            border-radius: 6px;\n            height: 100%;\n\n\n            @media #{$mq-sm} {\n                font-size: 13px;\n            }\n\n            h3 {\n                color: $fs-dark-grey;\n                margin-bottom: 5px;\n\n                a,\n                i {\n                    color: inherit;\n                }\n            }\n\n            &--ls {\n                li {\n                    list-style-type: disc;\n                    color: #676a6c;\n                }\n            }\n\n            &--sc {\n                p {\n                    font-weight: normal !important;\n                }\n            }\n\n            p {\n                font-size: 15px;\n                font-weight: 600;\n\n                @media #{$mq-sm} {\n                    font-size: 13px;\n                }\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n\n}\n\n.Del-data-btn {\n    padding: 40px 0;\n\n    .btn {\n        margin-left: 15px;\n        // border-color: #007bff;\n        background-color: #fff;\n        border-color: #f5f5f5;\n        color: #ff485c;\n    }\n\n    .cancelbtn {\n        color: #676a6c;\n        text-align: center;\n        font-size: 15px;\n        font-family: \"Open Sans\", sans-serif;\n        line-height: 1.5;\n        padding: 6px;\n    }\n}\n\n.stick-challenge {\n    position: relative;\n\n    .card-body__inner {\n        min-height: auto;\n        overflow-y: auto;\n        overflow-x: hidden;\n        z-index: 9;\n        position: relative;\n\n        .card-body__subtitle {\n            position: sticky;\n            top: 0;\n            z-index: 99;\n            background-color: #fff;\n        }\n    }\n\n}\n\n.trackInfo {\n    padding: 2px 16px;\n    background-color: #6d6e71;\n    color: #fff;\n    margin-left: 40px;\n    border-radius: 5px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    font-size: 10px;\n\n    &--inputclr {\n        color: #464646;\n        font-size: 11px;\n        background: transparent;\n        margin-left: 8px;\n        padding-left: 0;\n        margin-bottom: 2px;\n        display: inline-block;\n    }\n\n    &--pos {\n        position: absolute;\n        top: -18px;\n    }\n}\n\n.cdk-drag-preview {\n    border: 1px solid #ccc !important;\n    padding: 10px;\n\n    .dotactions__inner {\n        display: none;\n    }\n}\n\nspan.thinkeyebtn {\n    position: relative;\n    width: 100%;\n    display: inline-block;\n    text-align: right;\n    margin: 0px 0 6px;\n    cursor: pointer;\n}\n\n\n// Modal Design\n::ng-deep .modal {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1050;\n    display: none;\n    overflow: hidden;\n    -webkit-overflow-scrolling: touch;\n    outline: 0;\n\n    &.show {\n        display: block !important;\n    }\n\n    &.grey {\n        background: rgba(236, 236, 236, 0.9);\n    }\n\n    &.fade {\n        .modal-dialog {\n            transition: transform 0.3s ease-out;\n        }\n\n        &.in {\n            opacity: 1;\n        }\n    }\n\n    &.in {\n        .modal-dialog {\n            transform: translate(0, 0);\n        }\n    }\n\n    &.modal-open {\n        overflow-x: hidden;\n        overflow-y: auto;\n    }\n\n    .modal-dialog {\n        position: relative;\n        width: auto;\n        margin: 10px;\n\n        @media (min-width: 768px) {\n            width: 600px;\n            margin: 30px auto;\n        }\n\n        .modal-content {\n            background-clip: padding-box;\n            background-color: #FFFFFF;\n            border: 1px solid rgba(0, 0, 0, 0);\n            border-radius: 4px;\n            box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n            outline: 0 none;\n            position: relative;\n\n            .close {\n                float: right;\n                font-size: 21px;\n                font-weight: bold;\n                line-height: 1;\n                color: #000;\n                text-shadow: 0 1px 0 #fff;\n                filter: alpha(opacity=20);\n                opacity: 0.2;\n\n                &:focus-visible {\n                    outline: none;\n                }\n            }\n\n            button.close {\n                padding: 0;\n                cursor: pointer;\n                background: transparent;\n                border: 0;\n                -webkit-appearance: none;\n                appearance: none;\n            }\n\n            .modal-body {\n\n                form {\n\n                    .form-group {\n                        margin-bottom: 15px;\n                    }\n                }\n            }\n        }\n    }\n\n    .f-btn {\n        color: #fff;\n        font-size: 14px;\n        border-color: #73BF38;\n        background-color: #73BF38;\n\n        &:hover {\n            border-color: #4cae4c;\n            background-color: #4cae4c;\n        }\n\n        &--seagrn {\n            border-color: #1dc5a3;\n            background-color: #1dc5a3;\n\n            &:hover {\n                border-color: #1dc5a3;\n                background-color: #1dc5a3;\n            }\n        }\n\n        &--dngr {\n            color: #fff;\n            border-color: #ED5565;\n            background-color: #ED5565;\n\n            &:hover {\n                border-color: #ec4758;\n                background-color: #ec4758;\n            }\n        }\n\n        &--wht {\n            color: #ff485c;\n            border-color: #f5f5f5;\n            background-color: #fff;\n\n            &:hover {\n                color: #ff485c;\n                border-color: #f5f5f5;\n                background-color: #fff;\n            }\n        }\n\n        &--cncl {\n            color: #676a6c;\n            background-color: #fff;\n            border: 1px solid #F6F5F7;\n\n            &:hover {\n                color: #676a6c;\n                border: 1px solid #F6F5F7;\n                background-color: #fff;\n            }\n        }\n\n        &--info {\n            color: #fff;\n            border-color: #23c6c8;\n            background-color: #23c6c8;\n\n            &:hover {\n                border-color: #21b9bb;\n                background-color: #21b9bb;\n            }\n        }\n\n        &--wrng {\n            color: #fff;\n            border-color: #f8ac59;\n            background-color: #f8ac59;\n\n            &:hover {\n                border-color: #f7a54a;\n                background-color: #f7a54a;\n            }\n        }\n    }\n}\n\n::ng-deep.modal-open {\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
